import { buildRestaurantMenuCategoryTree } from '../utils/restaurantMenuCatalog';

/** Canonical product category tree (category -> subcategory -> type). */
export const categories = {
  'food-beverages': {
    name: 'Aliments & Boissons',
    nameAr: 'الأطعمة والمشروبات',
    subcategories: {
      'meat': {
        name: 'Viande',
        nameAr: 'اللحوم',
        types: [
          { key: 'beef', name: 'Viande de Bœuf', nameAr: 'لحم البقر' },
          { key: 'lamb', name: 'Viande d\'Agneau', nameAr: 'لحم الضأن' },
          { key: 'goat', name: 'Chèvre', nameAr: 'لحم الماعز' },
          { key: 'sheep', name: 'Mouton', nameAr: 'لحم الخروف' },
          { key: 'camel', name: 'Camel', nameAr: 'لحم الجمل' },
          { key: 'lamb-cut', name: 'Agneau', nameAr: 'لحم الضأن المقطع' },
          { key: 'ground-beef', name: 'Bœuf Haché', nameAr: 'لحم البقر المفروم' },
          { key: 'chicken', name: 'Poulet', nameAr: 'دجاج' },
          { key: 'turkey', name: 'Dinde', nameAr: 'ديك رومي' },
          { key: 'poultry', name: 'Volaille', nameAr: 'دواجن' },
          { key: 'sausages', name: 'Saucisses', nameAr: 'النقانق' },
          { key: 'charcuterie', name: 'Charcuterie', nameAr: 'اللحوم المصنعة' },
          { key: 'camel-meat', name: 'Viande de Chameau', nameAr: 'لحم الجمل' },
          { key: 'gazelle', name: 'Viande de Gazelle', nameAr: 'لحم الغزال' },
          { key: 'mauritanian-sheep', name: 'Viande de Mouton Mauritanien', nameAr: 'لحم الخروف الموريتاني' }
        ]
      },
      'fish-seafood': {
        name: 'Poisson & Fruits de Mer',
        nameAr: 'الأسماك والمأكولات البحرية',
        types: [
          { key: 'fish', name: 'Poisson', nameAr: 'سمك' },
          { key: 'river-fish', name: 'Poisson du Fleuve', nameAr: 'سمك النهر' },
          { key: 'sea-fish', name: 'Poisson de Mer', nameAr: 'سمك البحر' },
          { key: 'shrimp', name: 'Crevettes', nameAr: 'الروبيان' },
          { key: 'crab', name: 'Crabes', nameAr: 'السرطان' },
          { key: 'lobster', name: 'Langoustes', nameAr: 'الكركند' },
          { key: 'thiof', name: 'Thiof', nameAr: 'الثيوف' },
          { key: 'captain-fish', name: 'Capitaine', nameAr: 'الكابتن' },
          { key: 'sea-bream', name: 'Dorade', nameAr: 'الدوراد' },
          { key: 'grouper', name: 'Mérou', nameAr: 'الهامور' },
          { key: 'barracuda', name: 'Barracuda', nameAr: 'الباراكودا' },
          { key: 'tuna', name: 'Thon', nameAr: 'التونة' },
          { key: 'swordfish', name: 'Espadon', nameAr: 'أبو سيف' },
          { key: 'shark', name: 'Requin', nameAr: 'القرش' },
          { key: 'ray', name: 'Raie', nameAr: 'الراي' },
          { key: 'octopus', name: 'Poulpe', nameAr: 'الأخطبوط' },
          { key: 'squid', name: 'Calmar', nameAr: 'الحبار' },
          { key: 'cuttlefish', name: 'Seiche', nameAr: 'السبيدج' },
          { key: 'oysters', name: 'Huîtres', nameAr: 'المحار' },
          { key: 'mussels', name: 'Moules', nameAr: 'بلح البحر' },
          { key: 'shellfish', name: 'Coquillages', nameAr: 'المحاريات' },
          { key: 'salmon', name: 'Saumon', nameAr: 'السلمون' },
          { key: 'trout', name: 'Truite', nameAr: 'السلمون المرقط' },
          { key: 'sole', name: 'Sole', nameAr: 'السول' },
          { key: 'cod', name: 'Cabillaud', nameAr: 'القد' },
          { key: 'hake', name: 'Colin', nameAr: 'الكولن' },
          { key: 'mackerel', name: 'Maquereau', nameAr: 'الإسقمري' },
          { key: 'sardines', name: 'Sardines', nameAr: 'السردين' },
          { key: 'anchovies', name: 'Anchois', nameAr: 'الأنشوجة' }
        ]
      },
      'fresh-fruits': {
        name: 'Fruits Frais',
        nameAr: 'الفواكه الطازجة',
        types: [
          { key: 'apples', name: 'Pommes', nameAr: 'التفاح' },
          { key: 'bananas', name: 'Bananes', nameAr: 'الموز' },
          { key: 'oranges', name: 'Oranges', nameAr: 'البرتقال' },
          { key: 'grapes', name: 'Raisins', nameAr: 'العنب' },
          { key: 'strawberries', name: 'Fraises', nameAr: 'الفراولة' },
          { key: 'mangoes', name: 'Mangues', nameAr: 'المانجو' },
          { key: 'papayas', name: 'Papayes', nameAr: 'البابايا' },
          { key: 'pineapple', name: 'Ananas', nameAr: 'الأناناس' },
          { key: 'lemons', name: 'Citrons', nameAr: 'الليمون' },
          { key: 'grapefruit', name: 'Pamplemousses', nameAr: 'الجريب فروت' },
          { key: 'dates', name: 'Dattes', nameAr: 'التمر' },
          { key: 'figs', name: 'Figues', nameAr: 'التين' },
          { key: 'pomegranate', name: 'Grenades', nameAr: 'الرمان' },
          { key: 'watermelon', name: 'Pastèques', nameAr: 'البطيخ' },
          { key: 'melon', name: 'Melons', nameAr: 'الشمام' },
          { key: 'peaches', name: 'Pêches', nameAr: 'الخوخ' },
          { key: 'pears', name: 'Poires', nameAr: 'الكمثرى' },
          { key: 'plums', name: 'Prunes', nameAr: 'البرقوق' },
          { key: 'cherries', name: 'Cerises', nameAr: 'الكرز' },
          { key: 'kiwi', name: 'Kiwi', nameAr: 'الكيوي' },
          { key: 'avocados', name: 'Avocats', nameAr: 'الأفوكادو' }
        ]
      },
      'vegetables': {
        name: 'Légumes',
        nameAr: 'الخضروات',
        types: [
          { key: 'tomatoes', name: 'Tomates', nameAr: 'الطماطم' },
          { key: 'onions', name: 'Oignons', nameAr: 'البصل' },
          { key: 'carrots', name: 'Carottes', nameAr: 'الجزر' },
          { key: 'potatoes', name: 'Pommes de Terre', nameAr: 'البطاطس' },
          { key: 'lettuce', name: 'Laitue', nameAr: 'الخس' },
          { key: 'peppers', name: 'Poivrons', nameAr: 'الفلفل الحلو' },
          { key: 'cucumbers', name: 'Concombres', nameAr: 'الخيار' },
          { key: 'zucchini', name: 'Courgettes', nameAr: 'الكوسا' },
          { key: 'eggplant', name: 'Aubergines', nameAr: 'الباذنجان' },
          { key: 'cabbage', name: 'Choux', nameAr: 'الملفوف' },
          { key: 'broccoli', name: 'Brocolis', nameAr: 'البروكلي' },
          { key: 'spinach', name: 'Épinards', nameAr: 'السبانخ' },
          { key: 'celery', name: 'Céleri', nameAr: 'الكرفس' },
          { key: 'radish', name: 'Radis', nameAr: 'الفجل' },
          { key: 'beets', name: 'Betteraves', nameAr: 'الشمندر' },
          { key: 'sweet-potatoes', name: 'Patates Douces', nameAr: 'البطاطا الحلوة' },
          { key: 'garlic', name: 'Ail', nameAr: 'الثوم' },
          { key: 'ginger', name: 'Gingembre', nameAr: 'الزنجبيل' },
          { key: 'hot-peppers', name: 'Piments', nameAr: 'الفلفل الحار' },
          { key: 'green-beans', name: 'Haricots Verts', nameAr: 'الفاصوليا الخضراء' },
          { key: 'peas', name: 'Petits Pois', nameAr: 'البازلاء' },
          { key: 'mushrooms', name: 'Champignons', nameAr: 'الفطر' }
        ]
      },
      'dairy': {
        name: 'Produits Laitiers',
        nameAr: 'منتجات الألبان',
        types: [
          { key: 'milk', name: 'Lait', nameAr: 'الحليب' },
          { key: 'uht-milk', name: 'Lait UHT', nameAr: 'حليب طويل الأمد' },
          { key: 'powdered-milk', name: 'Lait en Poudre', nameAr: 'الحليب المجفف' },
          { key: 'condensed-milk', name: 'Lait Concentré', nameAr: 'الحليب المكثف' },
          { key: 'evaporated-milk', name: 'Lait Évaporé', nameAr: 'الحليب المبخر' },
          { key: 'plant-milk', name: 'Lait Végétal', nameAr: 'حليب نباتي' },
          { key: 'cheese', name: 'Fromage', nameAr: 'الجبن' },
          { key: 'processed-cheese', name: 'Fromage Fondu', nameAr: 'جبن مطبوخ' },
          { key: 'yogurt', name: 'Yaourt', nameAr: 'الزبادي' },
          { key: 'drinking-yogurt', name: 'Yaourt à Boire', nameAr: 'زبادي للشرب' },
          { key: 'butter', name: 'Beurre', nameAr: 'الزبدة' },
          { key: 'margarine', name: 'Margarine', nameAr: 'المارغرين' },
          { key: 'cream', name: 'Crème', nameAr: 'الكريمة' },
          { key: 'eggs', name: 'Œufs', nameAr: 'البيض' },
          { key: 'cottage-cheese', name: 'Fromage Blanc', nameAr: 'الجبن الأبيض' },
          { key: 'mozzarella', name: 'Mozzarella', nameAr: 'الموتزاريلا' },
          { key: 'cheddar', name: 'Cheddar', nameAr: 'الشيدر' },
          { key: 'emmental', name: 'Emmental', nameAr: 'الإيمنتال' },
          { key: 'camembert', name: 'Camembert', nameAr: 'الكامامبير' },
          { key: 'brie', name: 'Brie', nameAr: 'البري' },
          { key: 'feta', name: 'Feta', nameAr: 'الفيتا' },
          { key: 'parmesan', name: 'Parmesan', nameAr: 'البارميزان' },
          { key: 'labneh', name: 'Labneh', nameAr: 'اللبنة' },
          { key: 'leben', name: 'Lben / Raib', nameAr: 'اللبن الرائبب' }
        ]
      },
      'grains-cereals': {
        name: 'Céréales & Grains',
        nameAr: 'الحبوب والقمح',
        types: [
          { key: 'rice', name: 'Riz', nameAr: 'الأرز' },
          { key: 'wheat', name: 'Blé', nameAr: 'القمح' },
          { key: 'oats', name: 'Avoine', nameAr: 'الشوفان' },
          { key: 'barley', name: 'Orge', nameAr: 'الشعير' },
          { key: 'corn', name: 'Maïs', nameAr: 'الذرة' },
          { key: 'quinoa', name: 'Quinoa', nameAr: 'الكينوا' },
          { key: 'millet', name: 'Millet', nameAr: 'الدخن' },
          { key: 'sorghum', name: 'Sorgho', nameAr: 'السورغوم' },
          { key: 'basmati-rice', name: 'Riz Basmati', nameAr: 'أرز البسمتي' },
          { key: 'brown-rice', name: 'Riz Complet', nameAr: 'الأرز البني' },
          { key: 'arborio-rice', name: 'Riz Arborio', nameAr: 'أرز الأربوريو' },
          { key: 'wheat-flour', name: 'Farine de Blé', nameAr: 'دقيق القمح' },
          { key: 'corn-flour', name: 'Farine de Maïs', nameAr: 'دقيق الذرة' },
          { key: 'semolina', name: 'Semoule', nameAr: 'السميد' },
          { key: 'couscous', name: 'Couscous', nameAr: 'الكسكس' },
          { key: 'bulgur', name: 'Boulgour', nameAr: 'البرغل' },
          { key: 'pasta', name: 'Pâtes', nameAr: 'المعكرونة' },
          { key: 'spaghetti', name: 'Spaghettis', nameAr: 'السباغيتي' },
          { key: 'macaroni', name: 'Macaronis', nameAr: 'المكروني' },
          { key: 'noodles', name: 'Nouilles', nameAr: 'الشعيرية' },
          { key: 'bread', name: 'Pain', nameAr: 'الخبز' },
          { key: 'whole-bread', name: 'Pain Complet', nameAr: 'الخبز الكامل' },
          { key: 'rye-bread', name: 'Pain de Seigle', nameAr: 'خبز الجاودار' }
        ]
      },
      
      'beverages': {
        name: 'Boissons',
        nameAr: 'المشروبات',
        types: [
          { key: 'water', name: 'Eau', nameAr: 'الماء' },
          { key: 'sparkling-water', name: 'Eau Gazeuse', nameAr: 'الماء الغازي' },
          { key: 'coconut-water', name: 'Eau de Coco', nameAr: 'ماء جوز الهند' },
          { key: 'orange-juice', name: 'Jus d\'Orange', nameAr: 'عصير البرتقال' },
          { key: 'apple-juice', name: 'Jus de Pomme', nameAr: 'عصير التفاح' },
          { key: 'mango-juice', name: 'Jus de Mangue', nameAr: 'عصير المانجو' },
          { key: 'grape-juice', name: 'Jus de Raisin', nameAr: 'عصير العنب' },
          { key: 'coca-cola', name: 'Coca-Cola', nameAr: 'كوكا كولا' },
          { key: 'pepsi', name: 'Pepsi', nameAr: 'بيبسي' },
          { key: 'fanta', name: 'Fanta', nameAr: 'فانتا' },
          { key: 'sprite', name: 'Sprite', nameAr: 'سبرايت' },
          { key: 'coffee-beans', name: 'Café en Grains', nameAr: 'قهوة بالحبوب' },
          { key: 'ground-coffee', name: 'Café Moulu', nameAr: 'قهوة مطحونة' },
          { key: 'instant-coffee', name: 'Café Instantané', nameAr: 'قهوة سريعة التحضير' },
          { key: 'green-tea', name: 'Thé Vert', nameAr: 'الشاي الأخضر' },
          { key: 'black-tea', name: 'Thé Noir', nameAr: 'الشاي الأسود' },
          { key: 'mint-tea', name: 'Thé à la Menthe', nameAr: 'شاي بالنعناع' },
          { key: 'jasmine-tea', name: 'Thé au Jasmin', nameAr: 'شاي الياسمين' },
          { key: 'ginger-tea', name: 'Thé au Gingembre', nameAr: 'شاي الزنجبيل' },
          { key: 'lemonade', name: 'Limonade', nameAr: 'عصير الليمون' },
          { key: 'energy-drinks', name: 'Boissons Énergisantes', nameAr: 'مشروبات الطاقة' },
          { key: 'sports-drinks', name: 'Boissons Sportives', nameAr: 'مشروبات رياضية' },
          { key: 'smoothies', name: 'Smoothies', nameAr: 'العصائر المخلوطة' },
          { key: 'hot-chocolate', name: 'Chocolat Chaud', nameAr: 'الشوكولاتة الساخنة' }
        ]
      },
      'canned-preserved': {
        name: 'Conserves & Préservés',
        nameAr: 'المعلبات والمحفوظات',
        types: [
          { key: 'canned-tomatoes', name: 'Tomates en Conserve', nameAr: 'طماطم معلبة' },
          { key: 'canned-beans', name: 'Haricots en Conserve', nameAr: 'فاصوليا معلبة' },
          { key: 'canned-corn', name: 'Maïs en Conserve', nameAr: 'ذرة معلبة' },
          { key: 'canned-tuna', name: 'Thon en Conserve', nameAr: 'تونة معلبة' },
          { key: 'sardines', name: 'Sardines', nameAr: 'السردين' },
          { key: 'anchovies', name: 'Anchois', nameAr: 'الأنشوجة' },
          { key: 'olives', name: 'Olives', nameAr: 'الزيتون' },
          { key: 'pickles', name: 'Cornichons', nameAr: 'المخلل' },
          { key: 'jam', name: 'Confiture', nameAr: 'المربى' },
          { key: 'honey', name: 'Miel', nameAr: 'العسل' },
          { key: 'strawberry-jam', name: 'Confiture de Fraises', nameAr: 'مربى الفراولة' },
          { key: 'apricot-jam', name: 'Confiture d\'Abricot', nameAr: 'مربى المشمش' },
          { key: 'tomato-paste', name: 'Pâte de Tomate', nameAr: 'معجون الطماطم' },
          { key: 'tomato-sauce', name: 'Sauce Tomate', nameAr: 'صلصة الطماطم' }
        ]
      },
      'spices-condiments': {
        name: 'Épices & Condiments',
        nameAr: 'التوابل والبهارات',
        types: [
          { key: 'salt', name: 'Sel', nameAr: 'الملح' },
          { key: 'sugar', name: 'Sucre', nameAr: 'السكر' },
          { key: 'brown-sugar', name: 'Sucre Roux', nameAr: 'سكر بني' },
          { key: 'pepper', name: 'Poivre', nameAr: 'الفلفل الأسود' },
          { key: 'cumin', name: 'Cumin', nameAr: 'الكمون' },
          { key: 'coriander', name: 'Coriandre', nameAr: 'الكزبرة' },
          { key: 'cinnamon', name: 'Cannelle', nameAr: 'القرفة' },
          { key: 'ginger', name: 'Gingembre', nameAr: 'الزنجبيل' },
          { key: 'garlic', name: 'Ail', nameAr: 'الثوم' },
          { key: 'onion', name: 'Oignon', nameAr: 'البصل' },
          { key: 'paprika', name: 'Paprika', nameAr: 'البابريكا' },
          { key: 'curry', name: 'Curry', nameAr: 'الكاري' },
          { key: 'saffron', name: 'Safran', nameAr: 'الزعفران' },
          { key: 'cardamom', name: 'Cardamome', nameAr: 'الهيل' },
          { key: 'cloves', name: 'Clous de Girofle', nameAr: 'القرنفل' },
          { key: 'bay-leaves', name: 'Laurier', nameAr: 'أوراق الغار' },
          { key: 'thyme', name: 'Thym', nameAr: 'الزعتر' },
          { key: 'rosemary', name: 'Romarin', nameAr: 'إكليل الجبل' },
          { key: 'basil', name: 'Basilic', nameAr: 'الريحان' },
          { key: 'parsley', name: 'Persil', nameAr: 'البقدونس' },
          { key: 'mint', name: 'Menthe', nameAr: 'النعناع' },
          { key: 'vinegar', name: 'Vinaigre', nameAr: 'الخل' },
          { key: 'olive-oil', name: 'Huile d\'Olive', nameAr: 'زيت الزيتون' },
          { key: 'sunflower-oil', name: 'Huile de Tournesol', nameAr: 'زيت عباد الشمس' },
          { key: 'sea-salt', name: 'Sel de Mer', nameAr: 'ملح البحر' },
          { key: 'black-pepper', name: 'Poivre Noir', nameAr: 'الفلفل الأسود' },
          { key: 'white-pepper', name: 'Poivre Blanc', nameAr: 'الفلفل الأبيض' },
          { key: 'mustard', name: 'Moutarde de Dijon', nameAr: 'الخردل' },
          { key: 'ketchup', name: 'Ketchup', nameAr: 'الكاتشب' },
          { key: 'soy-sauce', name: 'Sauce Soja', nameAr: 'صلصة الصويا' },
          { key: 'harissa', name: 'Harissa', nameAr: 'الهريسة' },
          { key: 'ras-el-hanout', name: 'Ras el Hanout', nameAr: 'رأس الحانوت' },
          { key: 'zaatar', name: 'Za\'atar', nameAr: 'الزعتر' },
          { key: 'sumac', name: 'Sumac', nameAr: 'السماق' },
          { key: 'nigella', name: 'Nigelle', nameAr: 'الحبة السوداء' },
          { key: 'fenugreek', name: 'Fenugrec', nameAr: 'الحلبة' },
          { key: 'vegetable-oil', name: 'Huile Végétale', nameAr: 'زيت نباتي' },
          { key: 'corn-oil', name: 'Huile de Maïs', nameAr: 'زيت الذرة' },
          { key: 'palm-oil', name: 'Huile de Palme', nameAr: 'زيت النخيل' }
        ]
      },
      'sauces-dressings': {
        name: 'Sauces & Assaisonnements',
        nameAr: 'الصلصات والتتبيلات',
        types: [
          { key: 'mayonnaise', name: 'Mayonnaise', nameAr: 'مايونيز' },
          { key: 'garlic-mayo', name: 'Mayonnaise à l\'Ail / Aioli', nameAr: 'مايونيز بالثوم' },
          { key: 'salad-dressing', name: 'Sauce Salade', nameAr: 'صلصة سلطة' },
          { key: 'vinaigrette', name: 'Vinaigrette', nameAr: 'فينيجريت' },
          { key: 'ranch-dressing', name: 'Sauce Ranch', nameAr: 'صلصة رانش' },
          { key: 'cesar-dressing', name: 'Sauce César', nameAr: 'صلصة سيزر' },
          { key: 'barbecue-sauce', name: 'Sauce Barbecue', nameAr: 'صلصة باربيكيو' },
          { key: 'burger-sauce', name: 'Sauce Burger', nameAr: 'صلصة برغر' },
          { key: 'sauce-algerienne', name: 'Sauce Algérienne', nameAr: 'صلصة جزائرية' },
          { key: 'sauce-samurai', name: 'Sauce Samouraï', nameAr: 'صلصة ساموراي' },
          { key: 'sauce-andalouse', name: 'Sauce Andalouse', nameAr: 'صلصة أندلسية' },
          { key: 'sauce-blanche', name: 'Sauce Blanche', nameAr: 'صلصة بيضاء' },
          { key: 'chili-sauce', name: 'Sauce Chili', nameAr: 'صلصة فلفل حار' },
          { key: 'sweet-chili', name: 'Sauce Sweet Chili', nameAr: 'صلصة سويت تشيلي' },
          { key: 'hot-sauce', name: 'Sauce Piquante', nameAr: 'صلصة حارة' },
          { key: 'tartar-sauce', name: 'Sauce Tartare', nameAr: 'صلصة تارتار' },
          { key: 'cocktail-sauce', name: 'Sauce Cocktail', nameAr: 'صلصة كوكتيل' },
          { key: 'cheese-sauce', name: 'Sauce Fromage', nameAr: 'صلصة جبن' },
          { key: 'pesto', name: 'Pesto', nameAr: 'بيستو' },
          { key: 'worcestershire', name: 'Sauce Worcestershire', nameAr: 'صلصة ورسترشاير' },
          { key: 'fish-sauce', name: 'Sauce Poisson', nameAr: 'صلصة سمك' },
          { key: 'oyster-sauce', name: 'Sauce Huître', nameAr: 'صلصة محار' },
          { key: 'teriyaki-sauce', name: 'Sauce Teriyaki', nameAr: 'صلصة تيرياكي' },
          { key: 'hollandaise', name: 'Sauce Hollandaise', nameAr: 'صلصة هولنديز' },
          { key: 'bearnaise', name: 'Sauce Béarnaise', nameAr: 'صلصة بيرنيز' },
          { key: 'mayonnaise-light', name: 'Mayonnaise Légère', nameAr: 'مايونيز خفيف' },
          { key: 'other-sauce', name: 'Autre Sauce', nameAr: 'صلصة أخرى' }
        ]
      },
      'snacks-sweets': {
        name: 'Snacks & Sucreries',
        nameAr: 'الوجبات الخفيفة والحلويات',
        types: [
          { key: 'biscuits', name: 'Biscuits', nameAr: 'البسكويت' },
          { key: 'chips', name: 'Chips', nameAr: 'رقائق البطاطس' },
          { key: 'peanuts', name: 'Cacahuètes', nameAr: 'الفول السوداني' },
          { key: 'almonds', name: 'Amandes', nameAr: 'اللوز' },
          { key: 'walnuts', name: 'Noix', nameAr: 'الجوز' },
          { key: 'cashews', name: 'Noix de Cajou', nameAr: 'الكاجو' },
          { key: 'pistachios', name: 'Pistaches', nameAr: 'الفستق' },
          { key: 'hazelnuts', name: 'Noisettes', nameAr: 'البندق' },
          { key: 'dark-chocolate', name: 'Chocolat Noir', nameAr: 'الشوكولاتة الداكنة' },
          { key: 'milk-chocolate', name: 'Chocolat au Lait', nameAr: 'شوكولاتة بالحليب' },
          { key: 'white-chocolate', name: 'Chocolat Blanc', nameAr: 'الشوكولاتة البيضاء' },
          { key: 'truffles', name: 'Truffes', nameAr: 'الترافل' },
          { key: 'pralines', name: 'Pralines', nameAr: 'البرالين' },
          { key: 'candies', name: 'Bonbons', nameAr: 'الحلوى' },
          { key: 'gummy-candies', name: 'Bonbons Gélifiés', nameAr: 'الحلوى الهلامية' },
          { key: 'hard-candies', name: 'Bonbons Durs', nameAr: 'الحلوى الصلبة' },
          { key: 'caramels', name: 'Caramels', nameAr: 'الكراميل' },
          { key: 'cakes', name: 'Gâteaux', nameAr: 'الكعك' },
          { key: 'crackers', name: 'Crackers', nameAr: 'البسكويت المملح' },
          { key: 'popcorn', name: 'Popcorn', nameAr: 'الفشار' },
          { key: 'dried-dates', name: 'Dattes Séchées', nameAr: 'التمر المجفف' },
          { key: 'dried-figs', name: 'Figues Séchées', nameAr: 'التين المجفف' },
          { key: 'raisins', name: 'Raisins Secs', nameAr: 'الزبيب' },
          { key: 'dried-apricots', name: 'Abricots Secs', nameAr: 'المشمش المجفف' },
          { key: 'nougat', name: 'Nougat', nameAr: 'النوجا' },
          { key: 'halva', name: 'Halva', nameAr: 'الحلاوة' },
          { key: 'baklava', name: 'Baklava', nameAr: 'البقلاوة' },
          { key: 'turkish-delight', name: 'Loukoum', nameAr: 'الراحة التركية' },
          { key: 'chocolate-bars', name: 'Barres Chocolatées', nameAr: 'ألواح الشوكولاتة' },
          { key: 'wafer-chocolate', name: 'Gaufrettes Chocolatées', nameAr: 'ويفر بالشوكولاتة' },
          { key: 'cookies', name: 'Cookies', nameAr: 'الكوكيز' },
          { key: 'cereal-bars', name: 'Barres Céréales', nameAr: 'ألواح الحبوب' },
          { key: 'energy-bars', name: 'Barres Énergétiques', nameAr: 'ألواح الطاقة' },
          { key: 'chewing-gum', name: 'Chewing-gum', nameAr: 'علكة' },
          { key: 'marshmallows', name: 'Marshmallows', nameAr: 'مارشميلو' },
          { key: 'lollipops', name: 'Sucettes', nameAr: 'مصاصات' }
        ]
      },
      'spreads-toppings': {
        name: 'Pâtes à Tartiner & Confitures',
        nameAr: 'معلبات للدهن والمربى',
        types: [
          { key: 'chocolate-spread', name: 'Pâte à Tartiner Chocolat', nameAr: 'شوكولاتة للدهن' },
          { key: 'hazelnut-spread', name: 'Pâte Noisette / Chocolat-Noisette', nameAr: 'شوكولاتة بندق' },
          { key: 'peanut-butter', name: 'Beurre de Cacahuète', nameAr: 'زبدة الفول السوداني' },
          { key: 'almond-butter', name: 'Beurre d\'Amande', nameAr: 'زبدة اللوز' },
          { key: 'cheese-spread', name: 'Fromage à Tartiner', nameAr: 'جبن للدهن' },
          { key: 'jam', name: 'Confiture', nameAr: 'المربى' },
          { key: 'honey', name: 'Miel', nameAr: 'العسل' },
          { key: 'maple-syrup', name: 'Sirop d\'Érable', nameAr: 'شراب القيقب' },
          { key: 'chocolate-syrup', name: 'Sirop Chocolat', nameAr: 'شراب الشوكولاتة' },
          { key: 'caramel-spread', name: 'Pâte Caramel / Dulce de Leche', nameAr: 'كراميل للدهن' },
          { key: 'tahini', name: 'Tahini / Crème de Sésame', nameAr: 'طحينة' },
          { key: 'nutella-style', name: 'Pâte Choco-Noisette (type Nutella)', nameAr: 'شوكولاتة نوتيلا' }
        ]
      },
      'breakfast': {
        name: 'Petit-déjeuner',
        nameAr: 'الإفطار',
        types: [
          { key: 'breakfast-cereals', name: 'Céréales Petit-déjeuner', nameAr: 'حبوب الإفطار' },
          { key: 'cornflakes', name: 'Corn Flakes', nameAr: 'كورن فليكس' },
          { key: 'muesli', name: 'Muesli', nameAr: 'ميوزلي' },
          { key: 'granola', name: 'Granola', nameAr: 'جرانولا' },
          { key: 'oatmeal', name: 'Flocons d\'Avoine', nameAr: 'شوفان' },
          { key: 'chocolate-powder', name: 'Chocolat en Poudre', nameAr: 'كاكاو بودرة' },
          { key: 'hot-chocolate-mix', name: 'Chocolat Chaud Instantané', nameAr: 'شوكولاتة ساخنة فورية' },
          { key: 'instant-coffee', name: 'Café Instantané', nameAr: 'قهوة فورية' },
          { key: 'tea-bags', name: 'Sachets de Thé', nameAr: 'أكياس الشاي' },
          { key: 'toast-bread', name: 'Pain de Mie / Toast', nameAr: 'خبز التوست' },
          { key: 'croissant-pack', name: 'Croissants Emballés', nameAr: 'كرواسون معبأ' },
          { key: 'biscuits-breakfast', name: 'Biscuits Petit-déjeuner', nameAr: 'بسكويت الإفطار' }
        ]
      },
      'frozen': {
        name: 'Surgelés',
        nameAr: 'المجمدات',
        types: [
          { key: 'ice-cream', name: 'Glaces', nameAr: 'آيس كريم' },
          { key: 'ice-pops', name: 'Bâtonnets Glacés', nameAr: 'مثلجات بالعصا' },
          { key: 'frozen-vegetables', name: 'Légumes Surgelés', nameAr: 'خضار مجمدة' },
          { key: 'frozen-fries', name: 'Frites Surgelées', nameAr: 'بطاطس مقلية مجمدة' },
          { key: 'frozen-pizza', name: 'Pizza Surgelée', nameAr: 'بيتزا مجمدة' },
          { key: 'frozen-meals', name: 'Plats Surgelés', nameAr: 'وجبات مجمدة' },
          { key: 'frozen-fish', name: 'Poisson Surgelé', nameAr: 'سمك مجمد' },
          { key: 'frozen-meat', name: 'Viande Surgelée', nameAr: 'لحم مجمد' },
          { key: 'frozen-poultry', name: 'Volaille Surgelée', nameAr: 'دواجن مجمدة' },
          { key: 'frozen-pastry', name: 'Pâtisserie Surgelée', nameAr: 'معجنات مجمدة' },
          { key: 'frozen-bread', name: 'Pain Surgelé', nameAr: 'خبز مجمد' },
          { key: 'frozen-fruits', name: 'Fruits Surgelés', nameAr: 'فواكه مجمدة' }
        ]
      },
      'ready-meals': {
        name: 'Plats Préparés & Traiteur',
        nameAr: 'وجبات جاهزة ومعلبات طازجة',
        types: [
          { key: 'ready-meal', name: 'Plat Préparé', nameAr: 'وجبة جاهزة' },
          { key: 'instant-noodles', name: 'Nouilles Instantanées', nameAr: 'نودلز فورية' },
          { key: 'soup-packets', name: 'Soupes Instantanées', nameAr: 'شوربة فورية' },
          { key: 'couscous-kit', name: 'Couscous Préparé', nameAr: 'كسكس جاهز' },
          { key: 'pasta-kit', name: 'Pâtes Prêtes', nameAr: 'معكرونة جاهزة' },
          { key: 'sandwich', name: 'Sandwich', nameAr: 'ساندويتش' },
          { key: 'salad-bowl', name: 'Salade Préparée', nameAr: 'سلطة جاهزة' },
          { key: 'canned-meal', name: 'Plat en Boîte', nameAr: 'وجبة معلبة' },
          { key: 'baby-ready-meal', name: 'Repas Enfant', nameAr: 'وجبة أطفال' }
        ]
      },
      'oils-fats': {
        name: 'Huiles & Matières Grasses',
        nameAr: 'الزيوت والدهون',
        types: [
          { key: 'olive-oil', name: 'Huile d\'Olive', nameAr: 'زيت الزيتون' },
          { key: 'sunflower-oil', name: 'Huile de Tournesol', nameAr: 'زيت عباد الشمس' },
          { key: 'vegetable-oil', name: 'Huile Végétale', nameAr: 'زيت نباتي' },
          { key: 'corn-oil', name: 'Huile de Maïs', nameAr: 'زيت الذرة' },
          { key: 'palm-oil', name: 'Huile de Palme', nameAr: 'زيت النخيل' },
          { key: 'cooking-oil', name: 'Huile de Cuisine', nameAr: 'زيت الطبخ' },
          { key: 'ghee', name: 'Ghee / Beurre Clarifié', nameAr: 'سمن' },
          { key: 'shortening', name: 'Graisse de Cuisine', nameAr: 'دهن الطبخ' }
        ]
      },
      'mauritanian-traditional': {
        name: 'Produits Traditionnels Mauritaniens',
        nameAr: 'المنتجات التقليدية الموريتانية',
        types: [
          { key: 'thieboudienne', name: 'Thieboudienne', nameAr: 'الثيبودين' },
          { key: 'yassa', name: 'Yassa', nameAr: 'الياسا' },
          { key: 'mafe', name: 'Mafé', nameAr: 'المافي' },
          { key: 'mauritanian-couscous', name: 'Couscous Mauritanien', nameAr: 'الكسكس الموريتاني' },
          { key: 'fish-rice', name: 'Riz au Poisson', nameAr: 'أرز بالسمك' },
          { key: 'meat-rice', name: 'Riz à la Viande', nameAr: 'أرز باللحم' },
          { key: 'vegetable-rice', name: 'Riz aux Légumes', nameAr: 'أرز بالخضار' },
          { key: 'tomato-sauce', name: 'Sauce Tomate', nameAr: 'صلصة الطماطم' },
          { key: 'peanut-sauce', name: 'Sauce Arachide', nameAr: 'صلصة الفول السوداني' },
          { key: 'okra-sauce', name: 'Sauce Gombo', nameAr: 'صلصة البامية' },
          { key: 'spinach-sauce', name: 'Sauce Épinards', nameAr: 'صلصة السبانخ' },
          { key: 'sweet-potato-sauce', name: 'Sauce Patates Douces', nameAr: 'صلصة البطاطا الحلوة' },
          { key: 'traditional-bread', name: 'Pain Traditionnel', nameAr: 'الخبز التقليدي' },
          { key: 'millet-bread', name: 'Pain de Millet', nameAr: 'خبز الدخن' },
          { key: 'sorghum-bread', name: 'Pain de Sorgho', nameAr: 'خبز الذرة الرفيعة' },
          { key: 'corn-bread', name: 'Pain de Maïs', nameAr: 'خبز الذرة' },
          { key: 'date-bread', name: 'Pain aux Dattes', nameAr: 'خبز التمر' },
          { key: 'fig-bread', name: 'Pain aux Figues', nameAr: 'خبز التين' },
          { key: 'traditional-tea', name: 'Thé Traditionnel', nameAr: 'الشاي التقليدي' },
          { key: 'mint-tea', name: 'Thé à la Menthe', nameAr: 'أتاي النعناع' }
        ]
      }
    }
  },
  'boulangerie': {
    name: 'Boulangerie & Pâtisserie',
    nameAr: 'المخبز والحلويات',
    subcategories: {
      'bread': {
        name: 'Pains',
        nameAr: 'خبز',
        types: [
          { key: 'white-bread', name: 'Pain Blanc', nameAr: 'الخبز الأبيض' },
          { key: 'whole-bread', name: 'Pain Complet', nameAr: 'الخبز الكامل' },
          { key: 'rye-bread', name: 'Pain de Seigle', nameAr: 'خبز الجاودار' },
          { key: 'sandwich-bread', name: 'Pain de Mie', nameAr: 'خبز التوست' },
          { key: 'baguette', name: 'Baguette', nameAr: 'الباغيت' },
          { key: 'specialty-bread', name: 'Pains Spéciaux', nameAr: 'الخبز الخاص' }
        ]
      },
      'viennoiseries': {
        name: 'Viennoiseries',
        nameAr: 'معجنات',
        types: [
          { key: 'croissants', name: 'Croissants', nameAr: 'الكرواسون' },
          { key: 'pain-au-chocolat', name: 'Pains au Chocolat', nameAr: 'خبز بالشوكولاتة' },
          { key: 'brioches', name: 'Brioches', nameAr: 'البريوش' },
          { key: 'chaussons', name: 'Chaussons', nameAr: 'الشوسون' }
        ]
      },
      'patisserie': {
        name: 'Pâtisserie',
        nameAr: 'حلويات',
        types: [
          { key: 'cakes', name: 'Gâteaux', nameAr: 'الكعك' },
          { key: 'tarts', name: 'Tartes', nameAr: 'التارت' },
          { key: 'eclairs', name: 'Éclairs', nameAr: 'الإكلير' },
          { key: 'profiteroles', name: 'Profiteroles', nameAr: 'البروفيترول' },
          { key: 'macarons', name: 'Macarons', nameAr: 'الماكرون' },
          { key: 'madeleines', name: 'Madeleines', nameAr: 'المادلين' },
          { key: 'financiers', name: 'Financiers', nameAr: 'الفينانسيه' },
          { key: 'canneles', name: 'Cannelés', nameAr: 'الكانيليه' },
          { key: 'cookies', name: 'Cookies', nameAr: 'الكوكيز' },
          { key: 'biscuits', name: 'Biscuits', nameAr: 'البسكويت' }
        ]
      }
    }
  },
  'electronics': {
    name: 'Électronique',
    nameAr: 'الإلكترونيات',
    subcategories: {
      'smartphones': {
        name: 'Smartphones',
        nameAr: 'الهواتف الذكية',
        types: [
          { key: 'iphone', name: 'iPhone', nameAr: 'آيفون' },
          { key: 'samsung-galaxy', name: 'Samsung Galaxy', nameAr: 'سامسونغ غالاكسي' },
          { key: 'huawei', name: 'Huawei', nameAr: 'هواوي' },
          { key: 'xiaomi', name: 'Xiaomi', nameAr: 'شاومي' },
          { key: 'oneplus', name: 'OnePlus', nameAr: 'ون بلس' },
          { key: 'google-pixel', name: 'Google Pixel', nameAr: 'جوجل بكسل' },
          { key: 'sony-xperia', name: 'Sony Xperia', nameAr: 'سوني إكسبيريا' },
          { key: 'lg', name: 'LG', nameAr: 'ال جي' }
        ]
      },
      'computers': {
        name: 'Ordinateurs & Portables',
        nameAr: 'أجهزة الكمبيوتر والمحمولة',
        types: [
          { key: 'desktop-computer', name: 'Ordinateur de Bureau', nameAr: 'جهاز كمبيوتر مكتبي' },
          { key: 'laptop', name: 'Ordinateur Portable', nameAr: 'جهاز كمبيوتر محمول' },
          { key: 'tablet', name: 'Tablette', nameAr: 'جهاز لوحي' },
          { key: 'monitor', name: 'Écran', nameAr: 'شاشة' },
          { key: 'keyboard', name: 'Clavier', nameAr: 'لوحة مفاتيح' },
          { key: 'mouse', name: 'Souris', nameAr: 'فأرة' },
          { key: 'printer', name: 'Imprimante', nameAr: 'طابعة' },
          { key: 'scanner', name: 'Scanner', nameAr: 'ماسح ضوئي' }
        ]
      },
      'accessories': {
        name: 'Accessoires',
        nameAr: 'الملحقات',
        types: [
          { key: 'phone-cases', name: 'Coques de Téléphone', nameAr: 'أغطية الهاتف' },
          { key: 'screen-protectors', name: 'Protecteurs d\'Écran', nameAr: 'واقيات الشاشة' },
          { key: 'chargers', name: 'Chargeurs', nameAr: 'الشواحن' },
          { key: 'cables', name: 'Câbles', nameAr: 'الكابلات' },
          { key: 'headphones', name: 'Écouteurs', nameAr: 'سماعات الأذن' },
          { key: 'speakers', name: 'Haut-parleurs', nameAr: 'مكبرات الصوت' },
          { key: 'power-banks', name: 'Batteries Externes', nameAr: 'البطاريات الخارجية' },
          { key: 'memory-cards', name: 'Cartes Mémoire', nameAr: 'بطاقات الذاكرة' }
        ]
      },
      'gaming': {
        name: 'Jeux Vidéo',
        nameAr: 'ألعاب الفيديو',
        types: [
          { key: 'gaming-console', name: 'Console de Jeu', nameAr: 'وحدة تحكم الألعاب' },
          { key: 'gaming-laptop', name: 'Ordinateur Portable Gaming', nameAr: 'جهاز كمبيوتر محمول للألعاب' },
          { key: 'gaming-mouse', name: 'Souris Gaming', nameAr: 'فأرة الألعاب' },
          { key: 'gaming-keyboard', name: 'Clavier Gaming', nameAr: 'لوحة مفاتيح الألعاب' },
          { key: 'gaming-headset', name: 'Casque Gaming', nameAr: 'سماعة رأس للألعاب' },
          { key: 'controllers', name: 'Manettes', nameAr: 'أذرع التحكم' },
          { key: 'video-games', name: 'Jeux Vidéo', nameAr: 'ألعاب الفيديو' }
        ]
      },
      'audio-video': {
        name: 'Audio & Vidéo',
        nameAr: 'الصوت والفيديو',
        types: [
          { key: 'television', name: 'Télévision', nameAr: 'التلفزيون' },
          { key: 'home-cinema', name: 'Home Cinéma', nameAr: 'السينما المنزلية' },
          { key: 'bluetooth-speakers', name: 'Haut-parleurs Bluetooth', nameAr: 'مكبرات صوت بلوتوث' },
          { key: 'microphones', name: 'Microphones', nameAr: 'الميكروفونات' },
          { key: 'cameras', name: 'Appareils Photo', nameAr: 'الكاميرات' },
          { key: 'camcorders', name: 'Caméscopes', nameAr: 'كاميرات الفيديو' },
          { key: 'projectors', name: 'Projecteurs', nameAr: 'أجهزة الإسقاط' }
        ]
      },
      'home-appliances': {
        name: 'Électroménager',
        nameAr: 'الأجهزة المنزلية',
        types: [
          { key: 'refrigerator', name: 'Réfrigérateur', nameAr: 'الثلاجة' },
          { key: 'washing-machine', name: 'Machine à Laver', nameAr: 'غسالة الملابس' },
          { key: 'microwave', name: 'Micro-ondes', nameAr: 'الميكروويف' },
          { key: 'air-conditioner', name: 'Climatiseur', nameAr: 'مكيف الهواء' },
          { key: 'split-air-conditioner', name: 'Climatiseur Split', nameAr: 'مكيف سبليت' },
          { key: 'window-air-conditioner', name: 'Climatiseur Fenêtre', nameAr: 'مكيف نافذة' },
          { key: 'portable-air-conditioner', name: 'Climatiseur Mobile', nameAr: 'مكيف متحرك' },
          { key: 'fan', name: 'Ventilateur', nameAr: 'مروحة' },
          { key: 'water-cooler', name: 'Refroidisseur d\'Eau', nameAr: 'براد ماء' },
          { key: 'dishwasher', name: 'Lave-vaisselle', nameAr: 'غسالة الأطباق' },
          { key: 'vacuum-cleaner', name: 'Aspirateur', nameAr: 'المكنسة الكهربائية' },
          { key: 'blender', name: 'Mixeur', nameAr: 'الخلاط' },
          { key: 'coffee-machine', name: 'Machine à Café', nameAr: 'آلة القهوة' }
        ]
      },
      'smart-home': {
        name: 'Maison Connectée',
        nameAr: 'المنزل الذكي',
        types: [
          { key: 'smart-bulbs', name: 'Ampoules Intelligentes', nameAr: 'المصابيح الذكية' },
          { key: 'smart-plugs', name: 'Prises Intelligentes', nameAr: 'المقابس الذكية' },
          { key: 'security-cameras', name: 'Caméras de Sécurité', nameAr: 'كاميرات الأمان' },
          { key: 'smart-locks', name: 'Serrures Intelligentes', nameAr: 'الأقفال الذكية' },
          { key: 'smart-thermostat', name: 'Thermostat Intelligent', nameAr: 'منظم الحرارة الذكي' },
          { key: 'voice-assistants', name: 'Assistants Vocaux', nameAr: 'المساعدات الصوتية' },
          { key: 'smart-speakers', name: 'Haut-parleurs Intelligents', nameAr: 'مكبرات الصوت الذكية' }
        ]
      }
    }
  },
  'office-business-school': {
    name: 'Bureau, Entreprise & Scolaire',
    nameAr: 'المكتب والأعمال والمدرسة',
    subcategories: {
      'office-supplies': {
        name: 'Fournitures de Bureau',
        nameAr: 'مستلزمات المكتب',
        types: [
          { key: 'pens', name: 'Stylos', nameAr: 'الأقلام' },
          { key: 'pencils', name: 'Crayons', nameAr: 'أقلام الرصاص' },
          { key: 'erasers', name: 'Gommes', nameAr: 'الممحاة' },
          { key: 'rulers', name: 'Règles', nameAr: 'المساطر' },
          { key: 'calculators', name: 'Calculatrices', nameAr: 'الآلات الحاسبة' },
          { key: 'agendas', name: 'Agendas', nameAr: 'المفكرات' },
          { key: 'notebooks', name: 'Carnets', nameAr: 'الدفاتر' },
          { key: 'binders', name: 'Classeurs', nameAr: 'الملفات' },
          { key: 'folders', name: 'Chemises', nameAr: 'المجلدات' },
          { key: 'paper-clips', name: 'Trombones', nameAr: 'مشابك الورق' },
          { key: 'staplers', name: 'Agrafeuses', nameAr: 'الدباسات' },
          { key: 'paper', name: 'Papier', nameAr: 'الورق' },
          { key: 'envelopes', name: 'Enveloppes', nameAr: 'المظاريف' },
          { key: 'labels', name: 'Étiquettes', nameAr: 'الملصقات' },
          { key: 'stamps', name: 'Tampons', nameAr: 'الأختام' },
          { key: 'markers', name: 'Marqueurs', nameAr: 'أقلام التحديد' },
          { key: 'highlighters', name: 'Surligneurs', nameAr: 'أقلام الإبراز' }
        ]
      },
      'school-supplies': {
        name: 'Fournitures Scolaires',
        nameAr: 'المستلزمات المدرسية',
        types: [
          { key: 'notebooks', name: 'Cahiers', nameAr: 'الكراسات' },
          { key: 'books', name: 'Livres', nameAr: 'الكتب' },
          { key: 'backpacks', name: 'Cartables', nameAr: 'الحقائب المدرسية' },
          { key: 'pencil-cases', name: 'Trousses', nameAr: 'مقلمات' },
          { key: 'colored-pencils', name: 'Crayons de Couleur', nameAr: 'أقلام الألوان' },
          { key: 'markers', name: 'Feutres', nameAr: 'أقلام الفلوماستر' },
          { key: 'paint', name: 'Peinture', nameAr: 'الطلاء' },
          { key: 'brushes', name: 'Pinceaux', nameAr: 'الفرش' },
          { key: 'glue', name: 'Colle', nameAr: 'الصمغ' },
          { key: 'scissors', name: 'Ciseaux', nameAr: 'المقص' },
          { key: 'rulers', name: 'Règles', nameAr: 'المساطر' },
          { key: 'compasses', name: 'Compasses', nameAr: 'البوصلات' },
          { key: 'protractors', name: 'Rapporteurs', nameAr: 'المنقلات' },
          { key: 'squares', name: 'Équerres', nameAr: 'المثلثات' },
          { key: 'crayons', name: 'Crayons de Cire', nameAr: 'أقلام الشمع' },
          { key: 'modeling-clay', name: 'Pâte à Modeler', nameAr: 'عجينة التشكيل' }
        ]
      },
      'business-equipment': {
        name: 'Équipement Professionnel',
        nameAr: 'المعدات المهنية',
        types: [
          { key: 'printers', name: 'Imprimantes', nameAr: 'الطابعات' },
          { key: 'photocopiers', name: 'Photocopieurs', nameAr: 'آلات التصوير' },
          { key: 'phones', name: 'Téléphones', nameAr: 'الهواتف' },
          { key: 'fax', name: 'Fax', nameAr: 'الفاكس' },
          { key: 'projectors', name: 'Projecteurs', nameAr: 'أجهزة الإسقاط' },
          { key: 'whiteboards', name: 'Tableaux Blancs', nameAr: 'السبورات البيضاء' },
          { key: 'screens', name: 'Écrans', nameAr: 'الشاشات' },
          { key: 'audio-systems', name: 'Systèmes Audio', nameAr: 'أنظمة الصوت' },
          { key: 'security-cameras', name: 'Caméras de Surveillance', nameAr: 'كاميرات المراقبة' },
          { key: 'security-systems', name: 'Systèmes de Sécurité', nameAr: 'أنظمة الأمان' }
        ]
      },
      'furniture': {
        name: 'Mobilier de Bureau',
        nameAr: 'أثاث المكتب',
        types: [
          { key: 'desks', name: 'Bureaux', nameAr: 'المكاتب' },
          { key: 'chairs', name: 'Chaises', nameAr: 'الكراسي' },
          { key: 'cabinets', name: 'Armoires', nameAr: 'الخزائن' },
          { key: 'shelves', name: 'Étagères', nameAr: 'الأرفف' },
          { key: 'armchairs', name: 'Fauteuils', nameAr: 'الكراسي المكتبية' },
          { key: 'meeting-tables', name: 'Tables de Réunion', nameAr: 'طاولات الاجتماعات' },
          { key: 'bookcases', name: 'Bibliothèques', nameAr: 'خزائن الكتب' },
          { key: 'storage', name: 'Rangements', nameAr: 'وحدات التخزين' },
          { key: 'lecterns', name: 'Pupitres', nameAr: 'منصات المحاضرات' },
          { key: 'bulletin-boards', name: 'Tableaux d\'Affichage', nameAr: 'لوحات الإعلانات' }
        ]
      }
    }
  },
  'clothing': {
    name: 'Vêtements & Habillement',
    nameAr: 'الملابس والأزياء',
    subcategories: {
      'mens': {
        name: "Vêtements Hommes",
        nameAr: 'ملابس الرجال',
        types: [
          { key: 'shirts', name: 'Chemises', nameAr: 'القمصان' },
          { key: 'pants', name: 'Pantalons', nameAr: 'البناطيل' },
          { key: 'jackets', name: 'Vestes', nameAr: 'الجاكيتات' },
          { key: 'shoes', name: 'Chaussures', nameAr: 'الأحذية' },
          { key: 'accessories', name: 'Accessoires', nameAr: 'الإكسسوارات' },
          { key: 't-shirts', name: 'T-shirts', nameAr: 'التي شيرت' },
          { key: 'sweaters', name: 'Pulls', nameAr: 'البلوفرات' },
          { key: 'coats', name: 'Manteaux', nameAr: 'المعاطف' },
          { key: 'suits', name: 'Costumes', nameAr: 'البدلات' },
          { key: 'ties', name: 'Cravates', nameAr: 'ربطات العنق' },
          { key: 'underwear', name: 'Caleçons', nameAr: 'الملابس الداخلية' },
          { key: 'socks', name: 'Chaussettes', nameAr: 'الجوارب' },
          { key: 'belts', name: 'Ceintures', nameAr: 'الأحزمة' },
          { key: 'hats', name: 'Chapeaux', nameAr: 'القبعات' },
          { key: 'gloves', name: 'Gants', nameAr: 'القفازات' },
          { key: 'scarves', name: 'Écharpes', nameAr: 'الأوشحة' }
        ]
      },
      'womens': {
        name: "Vêtements Femmes",
        nameAr: 'ملابس النساء',
        types: [
          { key: 'dresses', name: 'Robes', nameAr: 'الفساتين' },
          { key: 'blouses', name: 'Blouses', nameAr: 'البلوزات' },
          { key: 'skirts', name: 'Jupes', nameAr: 'التنانير' },
          { key: 'shoes', name: 'Chaussures', nameAr: 'الأحذية' },
          { key: 'accessories', name: 'Accessoires', nameAr: 'الإكسسوارات' },
          { key: 't-shirts', name: 'T-shirts', nameAr: 'التي شيرت' },
          { key: 'sweaters', name: 'Pulls', nameAr: 'البلوفرات' },
          { key: 'coats', name: 'Manteaux', nameAr: 'المعاطف' },
          { key: 'pants', name: 'Pantalons', nameAr: 'البناطيل' },
          { key: 'shorts', name: 'Shorts', nameAr: 'الشورتات' },
          { key: 'leggings', name: 'Leggings', nameAr: 'الليجنز' },
          { key: 'underwear', name: 'Sous-vêtements', nameAr: 'الملابس الداخلية' },
          { key: 'tights', name: 'Collants', nameAr: 'الجوارب الطويلة' },
          { key: 'jewelry', name: 'Bijoux', nameAr: 'المجوهرات' },
          { key: 'bags', name: 'Sacs', nameAr: 'الحقائب' },
          { key: 'hats', name: 'Chapeaux', nameAr: 'القبعات' },
          { key: 'gloves', name: 'Gants', nameAr: 'القفازات' },
          { key: 'scarves', name: 'Écharpes', nameAr: 'الأوشحة' }
        ]
      },
      'kids': {
        name: 'Vêtements Enfants',
        nameAr: 'ملابس الأطفال',
        types: [
          { key: 'boys-clothes', name: 'Vêtements Garçons', nameAr: 'ملابس الأولاد' },
          { key: 'girls-clothes', name: 'Vêtements Filles', nameAr: 'ملابس البنات' },
          { key: 'baby-clothes', name: 'Vêtements Bébé', nameAr: 'ملابس الأطفال الرضع' },
          { key: 'shoes', name: 'Chaussures', nameAr: 'الأحذية' },
          { key: 'accessories', name: 'Accessoires', nameAr: 'الإكسسوارات' },
          { key: 't-shirts', name: 'T-shirts', nameAr: 'التي شيرت' },
          { key: 'pants', name: 'Pantalons', nameAr: 'البناطيل' },
          { key: 'dresses', name: 'Robes', nameAr: 'الفساتين' },
          { key: 'sweaters', name: 'Pulls', nameAr: 'البلوفرات' },
          { key: 'coats', name: 'Manteaux', nameAr: 'المعاطف' },
          { key: 'underwear', name: 'Sous-vêtements', nameAr: 'الملابس الداخلية' },
          { key: 'socks', name: 'Chaussettes', nameAr: 'الجوارب' },
          { key: 'hats', name: 'Chapeaux', nameAr: 'القبعات' },
          { key: 'gloves', name: 'Gants', nameAr: 'القفازات' },
          { key: 'scarves', name: 'Écharpes', nameAr: 'الأوشحة' }
        ]
      },
      'traditional': {
        name: 'Vêtements Traditionnels',
        nameAr: 'الملابس التقليدية',
        types: [
          { key: 'boubou', name: 'Boubou', nameAr: 'البوبو' },
          { key: 'kaftan', name: 'Kaftan', nameAr: 'القفطان' },
          { key: 'djellaba', name: 'Djellaba', nameAr: 'الجلابة' },
          { key: 'turban', name: 'Turban', nameAr: 'العمامة' },
          { key: 'veil', name: 'Voile', nameAr: 'الحجاب' },
          { key: 'chechia', name: 'Chéchia', nameAr: 'الشاشية' },
          { key: 'gandoura', name: 'Gandoura', nameAr: 'القندورة' },
          { key: 'seroual', name: 'Seroual', nameAr: 'السروال' },
          { key: 'burnous', name: 'Burnous', nameAr: 'البرنوس' },
          { key: 'taqiyah', name: 'Taqiyah', nameAr: 'الطاقية' }
        ]
      },
      'sports': {
        name: 'Vêtements de Sport',
        nameAr: 'ملابس الرياضة',
        types: [
          { key: 'jerseys', name: 'Maillots', nameAr: 'القمصان الرياضية' },
          { key: 'sports-shorts', name: 'Shorts Sport', nameAr: 'الشورتات الرياضية' },
          { key: 'tracksuits', name: 'Survêtements', nameAr: 'البدلات الرياضية' },
          { key: 'sports-shoes', name: 'Chaussures de Sport', nameAr: 'الأحذية الرياضية' },
          { key: 'tennis', name: 'Tennis', nameAr: 'التنس' },
          { key: 'football', name: 'Football', nameAr: 'كرة القدم' },
          { key: 'basketball', name: 'Basketball', nameAr: 'كرة السلة' },
          { key: 'gym-wear', name: 'Vêtements de Gym', nameAr: 'ملابس الجيم' },
          { key: 'running-wear', name: 'Vêtements de Course', nameAr: 'ملابس الجري' }
        ]
      }
    }
  },
  'health-beauty': {
    name: 'Santé & Beauté',
    nameAr: 'الصحة والجمال',
    subcategories: {
      'personal-care': {
        name: 'Soins Personnels',
        nameAr: 'العناية الشخصية',
        types: [
          { key: 'shampoo', name: 'Shampooing', nameAr: 'الشامبو' },
          { key: 'soap', name: 'Savon', nameAr: 'الصابون' },
          { key: 'toothpaste', name: 'Dentifrice', nameAr: 'معجون الأسنان' },
          { key: 'deodorant', name: 'Déodorant', nameAr: 'مزيل العرق' },
          { key: 'skincare', name: 'Soins de la Peau', nameAr: 'العناية بالبشرة' },
          { key: 'shower-gel', name: 'Gel Douche', nameAr: 'جل الاستحمام' },
          { key: 'conditioner', name: 'Après-shampooing', nameAr: 'بلسم الشعر' },
          { key: 'moisturizer', name: 'Crème Hydratante', nameAr: 'كريم مرطب' },
          { key: 'body-lotion', name: 'Lotion Corporelle', nameAr: 'لوشن الجسم' },
          { key: 'sunscreen', name: 'Crème Solaire', nameAr: 'واقي الشمس' },
          { key: 'razor', name: 'Rasoir', nameAr: 'شفرة الحلاقة' },
          { key: 'shaving-cream', name: 'Crème à Raser', nameAr: 'كريم الحلاقة' },
          { key: 'dental-floss', name: 'Fil Dentaire', nameAr: 'خيط الأسنان' },
          { key: 'mouthwash', name: 'Bain de Bouche', nameAr: 'غسول الفم' }
        ]
      },
      'cosmetics': {
        name: 'Cosmétiques',
        nameAr: 'مستحضرات التجميل',
        types: [
          { key: 'foundation', name: 'Fond de Teint', nameAr: 'كريم الأساس' },
          { key: 'lipstick', name: 'Rouge à Lèvres', nameAr: 'أحمر الشفاه' },
          { key: 'mascara', name: 'Mascara', nameAr: 'الماسكارا' },
          { key: 'eyeshadow', name: 'Fard à Paupières', nameAr: 'ظلال العيون' },
          { key: 'nail-polish', name: 'Vernis à Ongles', nameAr: 'طلاء الأظافر' },
          { key: 'powder', name: 'Poudre', nameAr: 'البودرة' },
          { key: 'blush', name: 'Blush', nameAr: 'أحمر الخدود' },
          { key: 'eyebrow-pencil', name: 'Crayon Sourcils', nameAr: 'قلم الحواجب' },
          { key: 'eyeliner', name: 'Crayon Yeux', nameAr: 'كحل العيون' },
          { key: 'cheek-color', name: 'Fard à Joues', nameAr: 'ألوان الخدود' },
          { key: 'highlighter', name: 'Highlighter', nameAr: 'الهايلايتر' },
          { key: 'contour', name: 'Contour', nameAr: 'الكونتور' },
          { key: 'primer', name: 'Primer', nameAr: 'البرايمر' },
          { key: 'setting-spray', name: 'Fixateur', nameAr: 'مثبت المكياج' }
        ]
      },
      'health': {
        name: 'Produits de Santé',
        nameAr: 'منتجات الصحة',
        types: [
          { key: 'vitamins', name: 'Vitamines', nameAr: 'الفيتامينات' },
          { key: 'supplements', name: 'Compléments', nameAr: 'المكملات الغذائية' },
          { key: 'first-aid', name: 'Premiers Soins', nameAr: 'الإسعافات الأولية' },
          { key: 'medical-devices', name: 'Appareils Médicaux', nameAr: 'الأجهزة الطبية' },
          { key: 'thermometer', name: 'Thermomètre', nameAr: 'مقياس الحرارة' },
          { key: 'blood-pressure-monitor', name: 'Tensiomètre', nameAr: 'جهاز قياس الضغط' },
          { key: 'masks', name: 'Masques', nameAr: 'الأقنعة' },
          { key: 'medical-gloves', name: 'Gants Médicaux', nameAr: 'القفازات الطبية' },
          { key: 'bandages', name: 'Pansements', nameAr: 'الضمادات' },
          { key: 'disinfectant', name: 'Désinfectant', nameAr: 'المطهر' },
          { key: 'compresses', name: 'Compresses', nameAr: 'الكمادات' },
          { key: 'medical-bandages', name: 'Bandages', nameAr: 'الأربطة الطبية' }
        ]
      },
      'hair-care': {
        name: 'Soins des Cheveux',
        nameAr: 'العناية بالشعر',
        types: [
          { key: 'shampoo', name: 'Shampooing', nameAr: 'الشامبو' },
          { key: 'conditioner', name: 'Après-shampooing', nameAr: 'بلسم الشعر' },
          { key: 'hair-mask', name: 'Masque Capillaire', nameAr: 'ماسك الشعر' },
          { key: 'hair-oil', name: 'Huile Capillaire', nameAr: 'زيت الشعر' },
          { key: 'styling-gel', name: 'Gel Coiffant', nameAr: 'جل تصفيف الشعر' },
          { key: 'hair-spray', name: 'Laque', nameAr: 'سبراي الشعر' },
          { key: 'hair-wax', name: 'Cire', nameAr: 'شمع الشعر' },
          { key: 'hair-color', name: 'Coloration', nameAr: 'صبغة الشعر' },
          { key: 'hair-relaxer', name: 'Défrisant', nameAr: 'كريم فرد الشعر' },
          { key: 'hair-straightener', name: 'Lisseur', nameAr: 'مكواة فرد الشعر' },
          { key: 'hair-curler', name: 'Boucleur', nameAr: 'مكواة تجعيد الشعر' },
          { key: 'hair-dryer', name: 'Sèche-cheveux', nameAr: 'مجفف الشعر' }
        ]
      },
      'skincare': {
        name: 'Soins de la Peau',
        nameAr: 'العناية بالبشرة',
        types: [
          { key: 'face-cleanser', name: 'Nettoyant Visage', nameAr: 'منظف الوجه' },
          { key: 'toner', name: 'Tonique', nameAr: 'التونر' },
          { key: 'serum', name: 'Sérum', nameAr: 'السيروم' },
          { key: 'day-cream', name: 'Crème de Jour', nameAr: 'كريم النهار' },
          { key: 'night-cream', name: 'Crème de Nuit', nameAr: 'كريم الليل' },
          { key: 'face-mask', name: 'Masque Visage', nameAr: 'ماسك الوجه' },
          { key: 'scrub', name: 'Gommage', nameAr: 'مقشر' },
          { key: 'exfoliant', name: 'Exfoliant', nameAr: 'مقشر' },
          { key: 'anti-aging-cream', name: 'Crème Anti-âge', nameAr: 'كريم مضاد للشيخوخة' },
          { key: 'eye-cream', name: 'Crème Contour des Yeux', nameAr: 'كريم حول العينين' },
          { key: 'body-oil', name: 'Huile Corporelle', nameAr: 'زيت الجسم' },
          { key: 'hand-cream', name: 'Crème Mains', nameAr: 'كريم اليدين' }
        ]
      }
    }
  },
  
  'household': {
    name: 'Articles Ménagers',
    nameAr: 'المستلزمات المنزلية',
    subcategories: {
      'cleaning': {
        name: 'Produits de Nettoyage',
        nameAr: 'منتجات التنظيف',
        types: [
          { key: 'detergent', name: 'Détergent', nameAr: 'المنظف' },
          { key: 'bleach', name: 'Eau de Javel', nameAr: 'الكلور' },
          { key: 'all-purpose-cleaner', name: 'Nettoyant Multi-usage', nameAr: 'منظف متعدد الاستخدامات' },
          { key: 'dish-soap', name: 'Liquide Vaisselle', nameAr: 'سائل الصحون' },
          { key: 'toilet-cleaner', name: 'Nettoyant WC', nameAr: 'منظف المرحاض' },
          { key: 'window-cleaner', name: 'Nettoyant Vitres', nameAr: 'منظف النوافذ' },
          { key: 'floor-cleaner', name: 'Nettoyant Sol', nameAr: 'منظف الأرضيات' },
          { key: 'kitchen-cleaner', name: 'Nettoyant Cuisine', nameAr: 'منظف المطبخ' },
          { key: 'bathroom-cleaner', name: 'Nettoyant Salle de Bain', nameAr: 'منظف الحمام' },
          { key: 'disinfectant', name: 'Désinfectant', nameAr: 'المطهر' },
          { key: 'descaler', name: 'Détartrant', nameAr: 'مزيل الترسبات' },
          { key: 'oven-cleaner', name: 'Nettoyant Four', nameAr: 'منظف الفرن' },
          { key: 'microwave-cleaner', name: 'Nettoyant Micro-ondes', nameAr: 'منظف الميكروويف' },
          { key: 'carpet-cleaner', name: 'Nettoyant Tapis', nameAr: 'منظف السجاد' },
          { key: 'furniture-cleaner', name: 'Nettoyant Meubles', nameAr: 'منظف الأثاث' },
          { key: 'furniture-wax', name: 'Cire Meubles', nameAr: 'شمع الأثاث' },
          { key: 'polish', name: 'Polish', nameAr: 'ملمع' },
          { key: 'cleaning-cloths', name: 'Chiffons', nameAr: 'قطع القماش' },
          { key: 'sponges', name: 'Éponges', nameAr: 'الإسفنج' },
          { key: 'broom', name: 'Balai', nameAr: 'المكنسة' },
          { key: 'mop', name: 'Serpillère', nameAr: 'الممسحة' },
          { key: 'vacuum-cleaner', name: 'Aspirateur', nameAr: 'المكنسة الكهربائية' },
          { key: 'laundry-detergent', name: 'Produit Lave-linge', nameAr: 'مسحوق الغسيل' },
          { key: 'fabric-softener', name: 'Adoucissant', nameAr: 'منعم الأقمشة' },
          { key: 'dishwasher-detergent', name: 'Détergent Lave-vaisselle', nameAr: 'منظف غسالة الأطباق' }
        ]
      },
      'kitchen-utensils': {
        name: 'Ustensiles de Cuisine',
        nameAr: 'أدوات المطبخ',
        types: [
          { key: 'pots', name: 'Casseroles', nameAr: 'الأواني' },
          { key: 'saucepan', name: 'Casserole', nameAr: 'قدر' },
          { key: 'stockpot', name: 'Marmite', nameAr: 'قدر كبير' },
          { key: 'pressure-cooker', name: 'Autocuiseur', nameAr: 'قدر الضغط' },
          { key: 'cooking-pot-set', name: 'Set de Casseroles', nameAr: 'طقم أواني طبخ' },
          { key: 'non-stick-pan', name: 'Poêle Antiadhésive', nameAr: 'مقلاة غير لاصقة' },
          { key: 'teapot', name: 'Théière', nameAr: 'إبريق الشاي' },
          { key: 'wok', name: 'Wok', nameAr: 'ووك' },
          { key: 'steamer-pot', name: 'Cuit-vapeur', nameAr: 'قدر بخار' },
          { key: 'pans', name: 'Poêles', nameAr: 'المقالي' },
          { key: 'cutlery', name: 'Couverts', nameAr: 'أدوات المائدة' },
          { key: 'plates', name: 'Assiettes', nameAr: 'الأطباق' },
          { key: 'glasses', name: 'Verres', nameAr: 'الأكواب الزجاجية' },
          { key: 'cups', name: 'Tasses', nameAr: 'الأكواب' },
          { key: 'bowls', name: 'Bol', nameAr: 'الأطباق العميقة' },
          { key: 'dishes', name: 'Plats', nameAr: 'الصحون' },
          { key: 'knives', name: 'Couteaux', nameAr: 'السكاكين' },
          { key: 'cutting-board', name: 'Planche à Découper', nameAr: 'لوح التقطيع' },
          { key: 'blender', name: 'Mixeur', nameAr: 'الخلاط' },
          { key: 'whisk', name: 'Fouet', nameAr: 'المخفقة' },
          { key: 'ladle', name: 'Louche', nameAr: 'المغرفة' },
          { key: 'skimmer', name: 'Écumoire', nameAr: 'المصفاة المثقبة' },
          { key: 'strainer', name: 'Passoire', nameAr: 'المصفاة' }
        ]
      },
      'storage': {
        name: 'Rangement',
        nameAr: 'التخزين',
        types: [
          { key: 'food-containers', name: 'Boîtes de Conservation', nameAr: 'علب الحفظ' },
          { key: 'freezer-bags', name: 'Sacs de Congélation', nameAr: 'أكياس التجميد' },
          { key: 'plastic-wrap', name: 'Film Plastique', nameAr: 'غلاف بلاستيكي' },
          { key: 'aluminum-foil', name: 'Papier Aluminium', nameAr: 'ورق الألمنيوم' },
          { key: 'tupperware', name: 'Tupperware', nameAr: 'التابروير' },
          { key: 'jars', name: 'Bocaux', nameAr: 'البرطمانات' },
          { key: 'airtight-containers', name: 'Contenants Hermétiques', nameAr: 'حاويات محكمة الإغلاق' }
        ]
      },
      'climate-comfort': {
        name: 'Climatisation & Ventilation',
        nameAr: 'التكييف والتهوية',
        types: [
          { key: 'split-air-conditioner', name: 'Climatiseur Split', nameAr: 'مكيف سبليت' },
          { key: 'window-air-conditioner', name: 'Climatiseur Fenêtre', nameAr: 'مكيف نافذة' },
          { key: 'portable-air-conditioner', name: 'Climatiseur Mobile', nameAr: 'مكيف متحرك' },
          { key: 'air-cooler', name: 'Refroidisseur d\'Air', nameAr: 'مبرّد هواء' },
          { key: 'fan', name: 'Ventilateur', nameAr: 'مروحة' },
          { key: 'ceiling-fan', name: 'Ventilateur Plafond', nameAr: 'مروحة سقف' },
          { key: 'heater', name: 'Chauffage', nameAr: 'سخان' },
          { key: 'humidifier', name: 'Humidificateur', nameAr: 'مرطب هواء' },
          { key: 'dehumidifier', name: 'Déshumidificateur', nameAr: 'مزيل الرطوبة' }
        ]
      },
      'water-supplies': {
        name: 'Eau & Hydratation',
        nameAr: 'الماء والترطيب',
        types: [
          { key: 'bottled-water-05', name: 'Eau 0,5 L', nameAr: 'ماء 0.5 لتر' },
          { key: 'bottled-water-15', name: 'Eau 1,5 L', nameAr: 'ماء 1.5 لتر' },
          { key: 'bottled-water-5', name: 'Eau 5 L', nameAr: 'ماء 5 لتر' },
          { key: 'water-gallon', name: 'Bonbonne d\'Eau', nameAr: 'قارورة ماء كبيرة' },
          { key: 'water-dispenser', name: 'Fontaine à Eau', nameAr: 'موزع الماء' },
          { key: 'water-filter', name: 'Filtre à Eau', nameAr: 'فلتر الماء' },
          { key: 'water-pump', name: 'Pompe à Eau', nameAr: 'مضخة ماء' }
        ]
      }
    }
  },
  'personal-care': {
    name: 'Hygiène & Soins Personnels',
    nameAr: 'النظافة والعناية الشخصية',
    subcategories: {
      'bathroom': {
        name: 'Salle de Bain',
        nameAr: 'حمام',
        types: [
          { key: 'soap', name: 'Savon', nameAr: 'الصابون' },
          { key: 'shower-gel', name: 'Gel Douche', nameAr: 'جل الاستحمام' },
          { key: 'shampoo', name: 'Shampooing', nameAr: 'الشامبو' },
          { key: 'conditioner', name: 'Après-shampooing', nameAr: 'بلسم الشعر' },
          { key: 'toothpaste', name: 'Dentifrice', nameAr: 'معجون الأسنان' },
          { key: 'toothbrush', name: 'Brosse à Dents', nameAr: 'فرشاة الأسنان' },
          { key: 'dental-floss', name: 'Fil Dentaire', nameAr: 'خيط الأسنان' },
          { key: 'mouthwash', name: 'Bain de Bouche', nameAr: 'غسول الفم' },
          { key: 'deodorant', name: 'Déodorant', nameAr: 'مزيل العرق' },
          { key: 'razor', name: 'Rasoir', nameAr: 'شفرة الحلاقة' },
          { key: 'shaving-cream', name: 'Crème à Raser', nameAr: 'كريم الحلاقة' },
          { key: 'towels', name: 'Serviettes', nameAr: 'المناشف' },
          { key: 'toilet-paper', name: 'Papier Toilette', nameAr: 'ورق التواليت' }
        ]
      },
      'skincare': {
        name: 'Soins de la Peau',
        nameAr: 'العناية بالبشرة',
        types: [
          { key: 'moisturizer', name: 'Crème Hydratante', nameAr: 'كريم مرطب' },
          { key: 'body-lotion', name: 'Lotion Corporelle', nameAr: 'لوشن الجسم' },
          { key: 'sunscreen', name: 'Crème Solaire', nameAr: 'واقي الشمس' },
          { key: 'face-cleanser', name: 'Nettoyant Visage', nameAr: 'منظف الوجه' },
          { key: 'toner', name: 'Tonique', nameAr: 'التونر' },
          { key: 'face-mask', name: 'Masque Visage', nameAr: 'ماسك الوجه' },
          { key: 'anti-aging-cream', name: 'Crème Anti-âge', nameAr: 'كريم مضاد للشيخوخة' },
          { key: 'serum', name: 'Sérum', nameAr: 'السيروم' },
          { key: 'body-oil', name: 'Huile Corporelle', nameAr: 'زيت الجسم' }
        ]
      },
      'hair-care': {
        name: 'Soins des Cheveux',
        nameAr: 'العناية بالشعر',
        types: [
          { key: 'shampoo', name: 'Shampooing', nameAr: 'الشامبو' },
          { key: 'conditioner', name: 'Après-shampooing', nameAr: 'بلسم الشعر' },
          { key: 'hair-mask', name: 'Masque Capillaire', nameAr: 'ماسك الشعر' },
          { key: 'hair-oil', name: 'Huile Capillaire', nameAr: 'زيت الشعر' },
          { key: 'styling-gel', name: 'Gel Coiffant', nameAr: 'جل تصفيف الشعر' },
          { key: 'hair-spray', name: 'Laque', nameAr: 'سبراي الشعر' },
          { key: 'hair-wax', name: 'Cire', nameAr: 'شمع الشعر' },
          { key: 'hair-color', name: 'Coloration', nameAr: 'صبغة الشعر' },
          { key: 'hair-relaxer', name: 'Défrisant', nameAr: 'كريم فرد الشعر' }
        ]
      }
    }
  },
  'baby-kids': {
    name: 'Bébé & Enfant',
    nameAr: 'الرضع والأطفال',
    subcategories: {
      'baby-food': {
        name: 'Alimentation Bébé',
        nameAr: 'طعام الأطفال',
        types: [
          { key: 'baby-formula', name: 'Lait en Poudre', nameAr: 'حليب الأطفال المجفف' },
          { key: 'baby-food-jars', name: 'Petits Pots', nameAr: 'برطمانات طعام الأطفال' },
          { key: 'baby-cereal', name: 'Céréales Bébé', nameAr: 'حبوب الأطفال' },
          { key: 'baby-biscuits', name: 'Biscuits Bébé', nameAr: 'بسكويت الأطفال' },
          { key: 'baby-compote', name: 'Compotes', nameAr: 'كومبوت الأطفال' },
          { key: 'baby-bottles', name: 'Biberons', nameAr: 'زجاجات الرضاعة' },
          { key: 'bottle-teats', name: 'Tétines', nameAr: 'حلمات الرضاعة' },
          { key: 'bibs', name: 'Bavoirs', nameAr: 'مرايل الأطفال' },
          { key: 'baby-porridge', name: 'Bouillies', nameAr: 'عصيدة الأطفال' },
          { key: 'baby-puree', name: 'Purées', nameAr: 'هريس الأطفال' },
          { key: 'mixed-fruits', name: 'Fruits Mixés', nameAr: 'فواكه مهروسة' },
          { key: 'mixed-vegetables', name: 'Légumes Mixés', nameAr: 'خضار مهروسة' },
          { key: 'mixed-meat', name: 'Viande Mixée', nameAr: 'لحم مهروس' },
          { key: 'mixed-fish', name: 'Poisson Mixé', nameAr: 'سمك مهروس' },
          { key: 'baby-yogurt', name: 'Yaourt Bébé', nameAr: 'زبادي الأطفال' },
          { key: 'baby-cheese', name: 'Fromage Bébé', nameAr: 'جبنة الأطفال' },
          { key: 'teething-biscuits', name: 'Biscuits de Dentition', nameAr: 'بسكويت التسنين' },
          { key: 'baby-snacks', name: 'Collations Bébé', nameAr: 'وجبات خفيفة للأطفال' },
          { key: 'baby-water', name: 'Eau pour Bébé', nameAr: 'ماء الأطفال' },
          { key: 'baby-juice', name: 'Jus Bébé', nameAr: 'عصير الأطفال' }
        ]
      },
      'baby-care': {
        name: 'Soins Bébé',
        nameAr: 'العناية بالرضع',
        types: [
          { key: 'diapers', name: 'Couches', nameAr: 'الحفاضات' },
          { key: 'diapers-newborn', name: 'Couches Nouveau-né', nameAr: 'حفاضات حديثي الولادة' },
          { key: 'diapers-pants', name: 'Culottes d\'Apprentissage / Pants', nameAr: 'سراويل حفاض' },
          { key: 'swim-diapers', name: 'Couches de Bain', nameAr: 'حفاضات السباحة' },
          { key: 'adult-diapers', name: 'Couches Adultes', nameAr: 'حفاضات كبار' },
          { key: 'baby-wipes', name: 'Lingettes', nameAr: 'مناديل الأطفال المبللة' },
          { key: 'diaper-cream', name: 'Crème pour Couches', nameAr: 'كريم الحفاضات' },
          { key: 'cleansing-milk', name: 'Lait de Toilette', nameAr: 'حليب التنظيف' },
          { key: 'baby-shampoo', name: 'Shampooing Bébé', nameAr: 'شامبو الأطفال' },
          { key: 'baby-shower-gel', name: 'Gel Douche Bébé', nameAr: 'جل استحمام الأطفال' },
          { key: 'baby-moisturizer', name: 'Crème Hydratante Bébé', nameAr: 'كريم مرطب للأطفال' },
          { key: 'baby-massage-oil', name: 'Huile de Massage Bébé', nameAr: 'زيت تدليك الأطفال' },
          { key: 'baby-powder', name: 'Poudre Bébé', nameAr: 'بودرة الأطفال' },
          { key: 'baby-sunscreen', name: 'Crème Solaire Bébé', nameAr: 'واقي شمس للأطفال' },
          { key: 'baby-cotton', name: 'Coton Bébé', nameAr: 'قطن أطفال' },
          { key: 'baby-thermometer', name: 'Thermomètre', nameAr: 'مقياس حرارة الأطفال' },
          { key: 'pacifier', name: 'Sucette', nameAr: 'اللهاية' },
          { key: 'baby-bottle-teats', name: 'Tétines', nameAr: 'حلمات الرضاعة' },
          { key: 'baby-bottles-care', name: 'Biberons', nameAr: 'زجاجات الرضاعة' },
          { key: 'sterilizer', name: 'Stérilisateur', nameAr: 'جهاز التعقيم' },
          { key: 'bottle-warmer', name: 'Chauffe-biberon', nameAr: 'دفاء الزجاجات' },
          { key: 'changing-mat', name: 'Matelas à Langer', nameAr: 'سجادة تغيير الحفاض' },
          { key: 'diaper-bag', name: 'Sac à Langer', nameAr: 'حقيبة الحفاضات' },
          { key: 'baby-sleepwear', name: 'Gigoteuses', nameAr: 'أكياس النوم للأطفال' },
          { key: 'baby-pajamas', name: 'Pyjamas Bébé', nameAr: 'بيجامات الأطفال' },
          { key: 'baby-bodysuit', name: 'Body Bébé', nameAr: 'بادي الأطفال' },
          { key: 'baby-rompers', name: 'Grenouillères', nameAr: 'سالوبيت الأطفال' },
          { key: 'baby-socks', name: 'Chaussettes Bébé', nameAr: 'جوارب الأطفال' },
          { key: 'baby-shoes', name: 'Chaussons Bébé', nameAr: 'أحذية الأطفال' },
          { key: 'baby-hat', name: 'Bonnet Bébé', nameAr: 'قبعة الأطفال' },
          { key: 'kids-clothing', name: 'Vêtements Enfant', nameAr: 'ملابس الأطفال' },
          { key: 'baby-bathtub', name: 'Baignoire Bébé', nameAr: 'حوض استحمام الأطفال' },
          { key: 'baby-bouncer', name: 'Transat Bébé', nameAr: 'كرسي هزاز للأطفال' },
          { key: 'stroller', name: 'Poussette', nameAr: 'عربة الأطفال' },
          { key: 'car-seat', name: 'Siège Auto Bébé', nameAr: 'مقعد السيارة للأطفال' },
          { key: 'playpen', name: 'Parc Bébé', nameAr: 'سياج اللعب للأطفال' },
          { key: 'baby-crib', name: 'Lit Bébé', nameAr: 'سرير الأطفال' },
          { key: 'baby-mattress', name: 'Matelas Bébé', nameAr: 'مرتبة الأطفال' },
          { key: 'night-light', name: 'Veilleuse Bébé', nameAr: 'إضاءة ليلية للأطفال' },
          { key: 'baby-mobile', name: 'Mobile Bébé', nameAr: 'موبايل الأطفال' },
          { key: 'baby-rattle', name: 'Hochet Bébé', nameAr: 'خشخيشة الأطفال' },
          { key: 'teething-ring', name: 'Anneau de Dentition', nameAr: 'حلقة التسنين' }
        ]
      },
      'kids-hygiene': {
        name: 'Hygiène Enfant',
        nameAr: 'نظافة الأطفال',
        types: [
          { key: 'kids-toothpaste', name: 'Dentifrice Enfant', nameAr: 'معجون أسنان أطفال' },
          { key: 'kids-toothbrush', name: 'Brosse à Dents Enfant', nameAr: 'فرشاة أسنان أطفال' },
          { key: 'kids-shampoo', name: 'Shampooing Enfant', nameAr: 'شامبو أطفال' },
          { key: 'kids-soap', name: 'Savon Enfant', nameAr: 'صابون أطفال' },
          { key: 'kids-body-wash', name: 'Gel Douche Enfant', nameAr: 'جل استحمام أطفال' },
          { key: 'kids-deodorant', name: 'Déodorant Enfant', nameAr: 'مزيل عرق أطفال' },
          { key: 'kids-tissues', name: 'Mouchoirs Enfant', nameAr: 'مناديل أطفال' },
          { key: 'kids-hand-sanitizer', name: 'Gel Hydroalcoolique Enfant', nameAr: 'معقم يدين أطفال' }
        ]
      },
      'toys': {
        name: 'Jouets',
        nameAr: 'الألعاب',
        types: [
          { key: 'dolls', name: 'Poupées', nameAr: 'الدمى' },
          { key: 'toy-cars', name: 'Voitures', nameAr: 'سيارات الألعاب' },
          { key: 'puzzles', name: 'Puzzles', nameAr: 'الألغاز' },
          { key: 'building-blocks', name: 'Jeux de Construction', nameAr: 'ألعاب البناء' },
          { key: 'stuffed-animals', name: 'Peluches', nameAr: 'الحيوانات المحشوة' },
          { key: 'educational-games', name: 'Jeux Éducatifs', nameAr: 'الألعاب التعليمية' },
          { key: 'childrens-books', name: 'Livres Enfants', nameAr: 'كتب الأطفال' },
          { key: 'board-games', name: 'Jeux de Société', nameAr: 'ألعاب الطاولة' },
          { key: 'card-games', name: 'Jeux de Cartes', nameAr: 'ألعاب الورق' },
          { key: 'video-games', name: 'Jeux Vidéo', nameAr: 'ألعاب الفيديو' },
          { key: 'game-consoles', name: 'Consoles de Jeu', nameAr: 'أجهزة الألعاب' },
          { key: 'game-controllers', name: 'Manettes', nameAr: 'أذرع التحكم' },
          { key: 'role-playing-games', name: 'Jeux de Rôle', nameAr: 'ألعاب الأدوار' },
          { key: 'strategy-games', name: 'Jeux de Stratégie', nameAr: 'ألعاب الاستراتيجية' },
          { key: 'memory-games', name: 'Jeux de Mémoire', nameAr: 'ألعاب الذاكرة' },
          { key: 'logic-games', name: 'Jeux de Logique', nameAr: 'ألعاب المنطق' },
          { key: 'math-games', name: 'Jeux de Calcul', nameAr: 'ألعاب الحساب' },
          { key: 'reading-games', name: 'Jeux de Lecture', nameAr: 'ألعاب القراءة' },
          { key: 'drawing-games', name: 'Jeux de Dessin', nameAr: 'ألعاب الرسم' },
          { key: 'painting-games', name: 'Jeux de Peinture', nameAr: 'ألعاب الرسم بالألوان' },
          { key: 'modeling-clay', name: 'Jeux de Pâte à Modeler', nameAr: 'ألعاب عجينة التشكيل' },
          { key: 'sand-games', name: 'Jeux de Sable', nameAr: 'ألعاب الرمل' },
          { key: 'water-games', name: 'Jeux d\'Eau', nameAr: 'ألعاب الماء' },
          { key: 'ball-games', name: 'Jeux de Ballon', nameAr: 'ألعاب الكرة' },
          { key: 'sports-toys', name: 'Jeux de Sport', nameAr: 'ألعاب رياضية' },
          { key: 'outdoor-toys', name: 'Jeux de Jardin', nameAr: 'ألعاب الحديقة' }
        ]
      }
    }
  },
  'pharmacy': {
    name: 'Pharmacie & Santé',
    nameAr: 'الصيدلية والصحة',
    subcategories: {
      'medicines': {
        name: 'Médicaments',
        nameAr: 'الأدوية',
        types: [
          // Médicaments essentiels
          { key: 'analgesics', name: 'Antalgiques', nameAr: 'مسكنات الألم' },
          { key: 'antibiotics', name: 'Antibiotiques', nameAr: 'المضادات الحيوية' },
          { key: 'vitamins', name: 'Vitamines', nameAr: 'الفيتامينات' },
          { key: 'supplements', name: 'Compléments Alimentaires', nameAr: 'المكملات الغذائية' },
          { key: 'prescription-drugs', name: 'Médicaments Prescrits', nameAr: 'الأدوية بوصفة طبية' },
          { key: 'otc-drugs', name: 'Médicaments en Vente Libre', nameAr: 'الأدوية بدون وصفة' },
          { key: 'antihistamines', name: 'Antihistaminiques', nameAr: 'مضادات الهيستامين' },
          { key: 'anti-inflammatory', name: 'Anti-inflammatoires', nameAr: 'مضادات الالتهاب' },
          { key: 'antispasmodics', name: 'Antispasmodiques', nameAr: 'مضادات التشنج' },
          { key: 'antidepressants', name: 'Antidépresseurs', nameAr: 'مضادات الاكتئاب' },
          { key: 'anticoagulants', name: 'Anticoagulants', nameAr: 'مضادات التخثر' },
          { key: 'antidiabetics', name: 'Antidiabétiques', nameAr: 'أدوية السكري' },
          { key: 'antihypertensives', name: 'Antihypertenseurs', nameAr: 'أدوية ضغط الدم' },
          { key: 'bronchodilators', name: 'Bronchodilatateurs', nameAr: 'موسعات الشعب الهوائية' },
          { key: 'corticoids', name: 'Corticoïdes', nameAr: 'الكورتيكويدات' },
          { key: 'diuretics', name: 'Diurétiques', nameAr: 'مدرات البول' },
          { key: 'laxatives', name: 'Laxatifs', nameAr: 'الملينات' },
          { key: 'antacids', name: 'Antiacides', nameAr: 'مضادات الحموضة' },
          { key: 'antifungals', name: 'Antifongiques', nameAr: 'مضادات الفطريات' },
          { key: 'antivirals', name: 'Antiviraux', nameAr: 'مضادات الفيروسات' },
          { key: 'paracetamol', name: 'Paracétamol', nameAr: 'الباراسيتامول' },
          { key: 'ibuprofen', name: 'Ibuprofène', nameAr: 'الإيبوبروفين' },
          { key: 'aspirin', name: 'Aspirine', nameAr: 'الأسبرين' },
          { key: 'doliprane', name: 'Doliprane', nameAr: 'الدوليبران' },
          { key: 'efferalgan', name: 'Efferalgan', nameAr: 'الإيفيرالجان' }
          // Médicaments spécialisés
          ,{ key: 'insulin', name: 'Insuline', nameAr: 'الإنسولين' },
          { key: 'vaccines', name: 'Vaccins', nameAr: 'اللقاحات' },
          { key: 'serum', name: 'Sérum', nameAr: 'المصل' },
          { key: 'morphine', name: 'Morphine', nameAr: 'المورفين' },
          { key: 'codeine', name: 'Codéine', nameAr: 'الكودايين' },
          { key: 'hormones', name: 'Hormones', nameAr: 'الهرمونات' },
          { key: 'nitroglycerin', name: 'Nitroglycérine', nameAr: 'النيتروجليسرين' },
          { key: 'dopamine', name: 'Dopamine', nameAr: 'الدوبامين' },
          { key: 'adrenaline', name: 'Adrénaline', nameAr: 'الأدرينالين' },
          { key: 'effervescent-tablets', name: 'Comprimés Effervescents', nameAr: 'الأقراص الفوارة' }
        ]
      },
      'first-aid': {
        name: 'Premiers Soins',
        nameAr: 'الإسعافات الأولية',
        types: [
          { key: 'bandages', name: 'Pansements', nameAr: 'الضمادات' },
          { key: 'disinfectant', name: 'Désinfectant', nameAr: 'المطهر' },
          { key: 'compresses', name: 'Compresses', nameAr: 'الكمادات' },
          { key: 'medical-bandages', name: 'Bandages', nameAr: 'الأربطة الطبية' },
          { key: 'thermometer', name: 'Thermomètre', nameAr: 'مقياس الحرارة' },
          { key: 'blood-pressure-monitor', name: 'Tensiomètre', nameAr: 'جهاز قياس الضغط' },
          { key: 'medical-masks', name: 'Masques', nameAr: 'الأقنعة الطبية' },
          { key: 'medical-gloves', name: 'Gants Médicaux', nameAr: 'القفازات الطبية' },
          { key: 'syringes', name: 'Seringues', nameAr: 'الحقن' },
          { key: 'needles', name: 'Aiguilles', nameAr: 'الإبر' },
          { key: 'oxygen', name: 'Oxygène', nameAr: 'الأكسجين' },
          { key: 'defibrillator', name: 'Défibrillateur', nameAr: 'جهاز إنعاش القلب' },
          { key: 'stethoscope', name: 'Stéthoscope', nameAr: 'السماعة الطبية' },
          { key: 'glucometer', name: 'Glucomètre', nameAr: 'جهاز قياس السكر' },
          { key: 'oximeter', name: 'Oxymètre', nameAr: 'جهاز قياس الأكسجين' },
          { key: 'nebulizer', name: 'Nébuliseur', nameAr: 'جهاز الاستنشاق' },
          { key: 'inhaler', name: 'Inhalateur', nameAr: 'البخاخ' },
          { key: 'walking-canes', name: 'Cannes', nameAr: 'العكازات' },
          { key: 'crutches', name: 'Béquilles', nameAr: 'العكازات الإبطية' },
          { key: 'wheelchair', name: 'Fauteuil Roulant', nameAr: 'الكرسي المتحرك' },
          { key: 'medical-bed', name: 'Lit Médical', nameAr: 'السرير الطبي' },
          { key: 'splint', name: 'Attelle', nameAr: 'الجبيرة' },
          { key: 'plaster-cast', name: 'Plâtre', nameAr: 'الجبس' },
          { key: 'cervical-collar', name: 'Collier Cervical', nameAr: 'طوق الرقبة' },
          { key: 'lumbar-belt', name: 'Ceinture Lombaire', nameAr: 'حزام أسفل الظهر' }
        ]
      },
      'health-supplements': {
        name: 'Compléments Santé',
        nameAr: 'المكملات الغذائية',
        types: [
          { key: 'vitamin-c', name: 'Vitamine C', nameAr: 'فيتامين ج' },
          { key: 'vitamin-d', name: 'Vitamine D', nameAr: 'فيتامين د' },
          { key: 'multivitamins', name: 'Multivitamines', nameAr: 'الفيتامينات المتعددة' },
          { key: 'omega-3', name: 'Oméga 3', nameAr: 'أوميجا 3' },
          { key: 'probiotics', name: 'Probiotiques', nameAr: 'البروبيوتيك' },
          { key: 'magnesium', name: 'Magnésium', nameAr: 'المغنيسيوم' },
          { key: 'iron', name: 'Fer', nameAr: 'الحديد' },
          { key: 'calcium', name: 'Calcium', nameAr: 'الكالسيوم' },
          { key: 'vitamin-b12', name: 'Vitamine B12', nameAr: 'فيتامين ب12' },
          { key: 'vitamin-e', name: 'Vitamine E', nameAr: 'فيتامين هـ' },
          { key: 'vitamin-a', name: 'Vitamine A', nameAr: 'فيتامين أ' },
          { key: 'zinc', name: 'Zinc', nameAr: 'الزنك' },
          { key: 'selenium', name: 'Sélénium', nameAr: 'السيلينيوم' },
          { key: 'potassium', name: 'Potassium', nameAr: 'البوتاسيوم' },
          { key: 'folic-acid', name: 'Acide Folique', nameAr: 'حمض الفوليك' },
          { key: 'coenzyme-q10', name: 'Coenzyme Q10', nameAr: 'الإنزيم المساعد كيو10' },
          { key: 'l-carnitine', name: 'L-Carnitine', nameAr: 'إل-كارنيتين' },
          { key: 'creatine', name: 'Créatine', nameAr: 'الكرياتين' },
          { key: 'protein-powder', name: 'Protéines en Poudre', nameAr: 'مسحوق البروتين' },
          { key: 'collagen', name: 'Collagène', nameAr: 'الكولاجين' },
          { key: 'glucosamine', name: 'Glucosamine', nameAr: 'الجلوكوزامين' },
          { key: 'melatonin', name: 'Mélatonine', nameAr: 'الميلاتونين' },
          { key: 'ginkgo-biloba', name: 'Ginkgo Biloba', nameAr: 'الجنكة' },
          { key: 'ginseng', name: 'Ginseng', nameAr: 'الجنسنج' },
          { key: 'echinacea', name: 'Échinacée', nameAr: 'الإكيناسيا' },
          { key: 'green-tea', name: 'Thé Vert', nameAr: 'الشاي الأخضر' },
          { key: 'turmeric', name: 'Curcuma', nameAr: 'الكركم' },
          { key: 'ginger', name: 'Gingembre', nameAr: 'الزنجبيل' },
          { key: 'garlic', name: 'Ail', nameAr: 'الثوم' },
          { key: 'aloe-vera', name: 'Aloès Vera', nameAr: 'الصبار' }
        ]
      }
    }
  },
  'automotive': {
    name: 'Automobile',
    nameAr: 'السيارات',
    subcategories: {
      'car-parts': {
        name: 'Pièces Auto',
        nameAr: 'قطع غيار السيارات',
        types: [
          { key: 'filters', name: 'Filtres', nameAr: 'المرشحات' },
          { key: 'spark-plugs', name: 'Bougies', nameAr: 'شمعات الإشعال' },
          { key: 'tires', name: 'Pneus', nameAr: 'الإطارات' },
          { key: 'battery', name: 'Batterie', nameAr: 'البطارية' },
          { key: 'engine-oil', name: 'Huile Moteur', nameAr: 'زيت المحرك' },
          { key: 'brake-fluid', name: 'Liquide de Frein', nameAr: 'سائل الفرامل' },
          { key: 'antifreeze', name: 'Antigel', nameAr: 'مضاد التجمد' },
          { key: 'windshield-washer', name: 'Liquide Lave-glace', nameAr: 'سائل غسيل الزجاج' }
        ]
      },
      'car-care': {
        name: 'Entretien Auto',
        nameAr: 'صيانة السيارات',
        types: [
          { key: 'car-wax', name: 'Cire Auto', nameAr: 'شمع السيارات' },
          { key: 'wheel-cleaner', name: 'Nettoyant Jantes', nameAr: 'منظف الجنوط' },
          { key: 'car-shampoo', name: 'Shampooing Auto', nameAr: 'شامبو السيارات' },
          { key: 'microfiber-cloths', name: 'Chiffons Microfibres', nameAr: 'قطع قماش الألياف الدقيقة' },
          { key: 'liquid-wax', name: 'Cire Liquide', nameAr: 'الشمع السائل' },
          { key: 'polish', name: 'Polish', nameAr: 'الملمع' }
        ]
      },
      'accessories': {
        name: 'Accessoires Auto',
        nameAr: 'إكسسوارات السيارات',
        types: [
          { key: 'seat-cushion', name: 'Coussin Siège', nameAr: 'وسادة المقعد' },
          { key: 'car-mats', name: 'Tapis Auto', nameAr: 'بساط السيارة' },
          { key: 'cup-holder', name: 'Porte-gobelets', nameAr: 'حامل الأكواب' },
          { key: 'usb-charger', name: 'Chargeur USB', nameAr: 'شاحن يو إس بي' },
          { key: 'phone-holder', name: 'Support Téléphone', nameAr: 'حامل الهاتف' },
          { key: 'rearview-mirror', name: 'Rétroviseur', nameAr: 'مرآة الرؤية الخلفية' }
        ]
      }
    }
  },
  'office-school': {
    name: 'Bureau & Scolaire',
    nameAr: 'المكتب والمدرسة',
    subcategories: {
      'stationery': {
        name: 'Fournitures de Bureau',
        nameAr: 'مستلزمات المكتب',
        types: [
          { key: 'pens', name: 'Stylos', nameAr: 'الأقلام' },
          { key: 'pencils', name: 'Crayons', nameAr: 'أقلام الرصاص' },
          { key: 'erasers', name: 'Gommes', nameAr: 'الممحاة' },
          { key: 'rulers', name: 'Règles', nameAr: 'المساطر' },
          { key: 'calculators', name: 'Calculatrices', nameAr: 'الآلات الحاسبة' },
          { key: 'planners', name: 'Agendas', nameAr: 'المفكرات' },
          { key: 'notebooks', name: 'Carnets', nameAr: 'الدفاتر' },
          { key: 'binders', name: 'Classeurs', nameAr: 'الملفات' },
          { key: 'folders', name: 'Chemises', nameAr: 'المجلدات' },
          { key: 'paper-clips', name: 'Trombones', nameAr: 'مشابك الورق' },
          { key: 'staplers', name: 'Agrafeuses', nameAr: 'الدباسات' }
        ]
      },
      'school-supplies': {
        name: 'Fournitures Scolaires',
        nameAr: 'المستلزمات المدرسية',
        types: [
          { key: 'notebooks', name: 'Cahiers', nameAr: 'الكراسات' },
          { key: 'textbooks', name: 'Livres', nameAr: 'الكتب المدرسية' },
          { key: 'backpacks', name: 'Cartables', nameAr: 'الحقائب المدرسية' },
          { key: 'pencil-cases', name: 'Trousses', nameAr: 'مقلمات' },
          { key: 'colored-pencils', name: 'Crayons de Couleur', nameAr: 'أقلام الألوان' },
          { key: 'markers', name: 'Feutres', nameAr: 'أقلام الفلوماستر' },
          { key: 'paint', name: 'Peinture', nameAr: 'الطلاء' },
          { key: 'brushes', name: 'Pinceaux', nameAr: 'الفرش' },
          { key: 'glue', name: 'Colle', nameAr: 'الصمغ' },
          { key: 'scissors', name: 'Ciseaux', nameAr: 'المقص' }
        ]
      },
      'office-equipment': {
        name: 'Équipement Bureau',
        nameAr: 'معدات المكتب',
        types: [
          { key: 'printers', name: 'Imprimantes', nameAr: 'الطابعات' },
          { key: 'paper', name: 'Papier', nameAr: 'الورق' },
          { key: 'ink', name: 'Encre', nameAr: 'الحبر' },
          { key: 'toner', name: 'Toner', nameAr: 'التونر' },
          { key: 'phones', name: 'Téléphones', nameAr: 'الهواتف' },
          { key: 'calculators', name: 'Calculatrices', nameAr: 'الآلات الحاسبة' },
          { key: 'labels', name: 'Étiquettes', nameAr: 'الملصقات' },
          { key: 'stamps', name: 'Tampons', nameAr: 'الأختام' }
        ]
      }
    }
  },
  'home-garden': {
    name: 'Maison & Jardin',
    nameAr: 'المنزل والحديقة',
    subcategories: {
      'furniture': {
        name: 'Mobilier',
        nameAr: 'الأثاث',
        types: [
          { key: 'tables', name: 'Tables', nameAr: 'الطاولات' },
          { key: 'chairs', name: 'Chaises', nameAr: 'الكراسي' },
          { key: 'wardrobes', name: 'Armoires', nameAr: 'الخزائن' },
          { key: 'shelves', name: 'Étagères', nameAr: 'الأرفف' },
          { key: 'beds', name: 'Lits', nameAr: 'الأسرة' },
          { key: 'sofas', name: 'Canapés', nameAr: 'الأرائك' },
          { key: 'armchairs', name: 'Fauteuils', nameAr: 'الكراسي المريحة' },
          { key: 'tv-stands', name: 'Meubles TV', nameAr: 'طاولات التلفزيون' },
          { key: 'desks', name: 'Bureaux', nameAr: 'المكاتب' },
          { key: 'outdoor-furniture', name: 'Mobilier Extérieur', nameAr: 'أثاث خارجي' },
          { key: 'garden-benches', name: 'Bancs de Jardin', nameAr: 'مقاعد حديقة' },
          { key: 'storage-furniture', name: 'Meubles de Rangement', nameAr: 'أثاث تخزين' }
        ]
      },
      'decoration': {
        name: 'Décoration',
        nameAr: 'الديكور',
        types: [
          { key: 'frames', name: 'Cadres', nameAr: 'الإطارات' },
          { key: 'vases', name: 'Vases', nameAr: 'المزهريات' },
          { key: 'candles', name: 'Bougies', nameAr: 'الشموع' },
          { key: 'clocks', name: 'Horloges', nameAr: 'الساعات' },
          { key: 'mirrors', name: 'Miroirs', nameAr: 'المرايا' },
          { key: 'rugs', name: 'Tapis', nameAr: 'السجاد' },
          { key: 'curtains', name: 'Rideaux', nameAr: 'الستائر' },
          { key: 'cushions', name: 'Coussins', nameAr: 'الوسائد' },
          { key: 'paintings', name: 'Tableaux', nameAr: 'اللوحات' },
          { key: 'wall-decors', name: 'Déco Murale', nameAr: 'ديكور جداري' },
          { key: 'artificial-plants', name: 'Plantes Artificielles', nameAr: 'نباتات صناعية' }
        ]
      },
      'garden': {
        name: 'Jardin & Extérieur',
        nameAr: 'الحديقة والخارج',
        types: [
          { key: 'plants', name: 'Plantes', nameAr: 'النباتات' },
          { key: 'pots', name: 'Pots', nameAr: 'الأصص' },
          { key: 'planters', name: 'Jardinières', nameAr: 'أحواض زراعة' },
          { key: 'soil', name: 'Terreau', nameAr: 'التربة' },
          { key: 'fertilizer', name: 'Engrais', nameAr: 'السماد' },
          { key: 'seeds', name: 'Semences', nameAr: 'البذور' },
          { key: 'garden-tools', name: 'Outils Jardin', nameAr: 'أدوات الحديقة' },
          { key: 'lawn-mowers', name: 'Tondeuses', nameAr: 'جزازات عشب' },
          { key: 'trimmers', name: 'Taille-haies / Coupe-bordures', nameAr: 'مقصات سياج' },
          { key: 'leaf-blowers', name: 'Souffleurs', nameAr: 'نافخات أوراق' },
          { key: 'watering-cans', name: 'Arrosoirs', nameAr: 'علب الري' },
          { key: 'garden-hoses', name: 'Tuyaux d\'Arrosage', nameAr: 'خراطيم ري' },
          { key: 'irrigation', name: 'Irrigation / Arrosage', nameAr: 'أنظمة ري' },
          { key: 'sprinklers', name: 'Arroseurs', nameAr: 'رشاشات' },
          { key: 'garden-gloves', name: 'Gants Jardin', nameAr: 'قفازات الحديقة' },
          { key: 'composters', name: 'Composteurs', nameAr: 'صناديق سماد' },
          { key: 'garden-fencing', name: 'Clôtures Jardin', nameAr: 'أسوار حديقة' },
          { key: 'garden-gates', name: 'Portails / Portillons', nameAr: 'بوابات حديقة' },
          { key: 'garden-sheds', name: 'Abris de Jardin', nameAr: 'أكواخ حديقة' },
          { key: 'bbq-grills', name: 'Barbecues', nameAr: 'شوايات' },
          { key: 'patio-heaters', name: 'Chauffages Terrasse', nameAr: 'دفايات تراس' },
          { key: 'parasols', name: 'Parasols', nameAr: 'مظلات' },
          { key: 'pest-control', name: 'Anti-nuisibles Jardin', nameAr: 'مكافحة آفات' },
          { key: 'pool-supplies', name: 'Piscine / Accessoires', nameAr: 'مستلزمات مسبح' }
        ]
      }
    }
  },
  'sports-outdoor': {
    name: 'Sport & Plein Air',
    nameAr: 'الرياضة والهواء الطلق',
    subcategories: {
      'sports-equipment': {
        name: 'Équipement Sport',
        nameAr: 'معدات الرياضة',
        types: [
          { key: 'balls', name: 'Ballons', nameAr: 'الكرات' },
          { key: 'rackets', name: 'Raquettes', nameAr: 'المضارب' },
          { key: 'bicycles', name: 'Vélos', nameAr: 'الدراجات الهوائية' },
          { key: 'exercise-mats', name: 'Tapis de Sport', nameAr: 'بساط التمرين' },
          { key: 'dumbbells', name: 'Haltères', nameAr: 'الأثقال' },
          { key: 'ropes', name: 'Cordes', nameAr: 'الحبال' },
          { key: 'resistance-bands', name: 'Élastiques', nameAr: 'الأشرطة المطاطية' },
          { key: 'protective-gear', name: 'Protections', nameAr: 'معدات الحماية' }
        ]
      },
      'outdoor': {
        name: 'Plein Air',
        nameAr: 'الهواء الطلق',
        types: [
          { key: 'tents', name: 'Tentes', nameAr: 'الخيام' },
          { key: 'sleeping-bags', name: 'Sac de Couchage', nameAr: 'أكياس النوم' },
          { key: 'hiking-shoes', name: 'Chaussures Randonnée', nameAr: 'أحذية المشي' },
          { key: 'sports-clothing', name: 'Vêtements Sport', nameAr: 'الملابس الرياضية' },
          { key: 'water-bottles', name: 'Gourdes', nameAr: 'قوارير الماء' },
          { key: 'flashlights', name: 'Lampes', nameAr: 'المصابيح' },
          { key: 'compasses', name: 'Boussoles', nameAr: 'البوصلات' }
        ]
      },
      'fitness': {
        name: 'Fitness',
        nameAr: 'اللياقة البدنية',
        types: [
          { key: 'treadmill', name: 'Tapis de Course', nameAr: 'جهاز المشي' },
          { key: 'exercise-bike', name: 'Vélo d\'Appartement', nameAr: 'دراجة التمرين' },
          { key: 'weights', name: 'Haltères', nameAr: 'الأوزان' },
          { key: 'resistance-bands', name: 'Élastiques', nameAr: 'الأشرطة المطاطية' },
          { key: 'yoga', name: 'Yoga', nameAr: 'اليوغا' },
          { key: 'pilates', name: 'Pilates', nameAr: 'البيلاتس' },
          { key: 'cardio', name: 'Cardio', nameAr: 'تمارين القلب' }
        ]
      }
    }
  },
  'books-media': {
    name: 'Livres & Médias',
    nameAr: 'الكتب والإعلام',
    subcategories: {
      'books': {
        name: 'Livres',
        nameAr: 'الكتب',
        types: [
          { key: 'novels', name: 'Romans', nameAr: 'الروايات' },
          { key: 'textbooks', name: 'Livres Scolaires', nameAr: 'الكتب المدرسية' },
          { key: 'religious-books', name: 'Livres Religieux', nameAr: 'الكتب الدينية' },
          { key: 'dictionaries', name: 'Dictionnaires', nameAr: 'القواميس' },
          { key: 'encyclopedias', name: 'Encyclopédies', nameAr: 'الموسوعات' },
          { key: 'history-books', name: 'Livres d\'Histoire', nameAr: 'كتب التاريخ' },
          { key: 'cookbooks', name: 'Livres de Cuisine', nameAr: 'كتب الطبخ' },
          { key: 'childrens-books', name: 'Livres pour Enfants', nameAr: 'كتب الأطفال' }
        ]
      },
      'media': {
        name: 'Médias',
        nameAr: 'الإعلام',
        types: [
          { key: 'cds', name: 'CD', nameAr: 'الأقراص المدمجة' },
          { key: 'dvds', name: 'DVD', nameAr: 'أقراص الفيديو' },
          { key: 'usb-drives', name: 'Clés USB', nameAr: 'محركات يو إس بي' },
          { key: 'memory-cards', name: 'Cartes Mémoire', nameAr: 'بطاقات الذاكرة' },
          { key: 'cables', name: 'Câbles', nameAr: 'الكابلات' },
          { key: 'adapters', name: 'Adaptateurs', nameAr: 'المحولات' },
          { key: 'players', name: 'Lecteurs', nameAr: 'مشغلات الوسائط' },
          { key: 'speakers', name: 'Enceintes', nameAr: 'السماعات' }
        ]
      },
      'magazines': {
        name: 'Magazines',
        nameAr: 'المجلات',
        types: [
          { key: 'news-magazines', name: 'Magazines Actualités', nameAr: 'مجلات الأخبار' },
          { key: 'sports-magazines', name: 'Magazines Sport', nameAr: 'مجلات الرياضة' },
          { key: 'fashion-magazines', name: 'Magazines Mode', nameAr: 'مجلات الموضة' },
          { key: 'cooking-magazines', name: 'Magazines Cuisine', nameAr: 'مجلات الطبخ' },
          { key: 'health-magazines', name: 'Magazines Santé', nameAr: 'مجلات الصحة' },
          { key: 'newspapers', name: 'Journaux', nameAr: 'الصحف' }
        ]
      }
    }
  },
  'jewelry-watches': {
    name: 'Bijoux & Montres',
    nameAr: 'المجوهرات والساعات',
    subcategories: {
      'jewelry': {
        name: 'Bijoux',
        nameAr: 'المجوهرات',
        types: [
          { key: 'necklaces', name: 'Colliers', nameAr: 'القلائد' },
          { key: 'rings', name: 'Bagues', nameAr: 'الخواتم' },
          { key: 'earrings', name: 'Boucles d\'Oreilles', nameAr: 'الأقراط' },
          { key: 'bracelets', name: 'Bracelets', nameAr: 'الأساور' },
          { key: 'watches', name: 'Montres', nameAr: 'الساعات' },
          { key: 'gold-jewelry', name: 'Bijoux en Or', nameAr: 'المجوهرات الذهبية' },
          { key: 'silver-jewelry', name: 'Bijoux en Argent', nameAr: 'المجوهرات الفضية' },
          { key: 'fashion-jewelry', name: 'Bijoux Fantaisie', nameAr: 'المجوهرات المقلدة' }
        ]
      },
      'watches': {
        name: 'Montres',
        nameAr: 'الساعات',
        types: [
          { key: 'mens-watches', name: 'Montres Homme', nameAr: 'ساعات الرجال' },
          { key: 'womens-watches', name: 'Montres Femme', nameAr: 'ساعات النساء' },
          { key: 'kids-watches', name: 'Montres Enfant', nameAr: 'ساعات الأطفال' },
          { key: 'smartwatches', name: 'Montres Connectées', nameAr: 'الساعات الذكية' },
          { key: 'sports-watches', name: 'Montres de Sport', nameAr: 'ساعات رياضية' },
          { key: 'luxury-watches', name: 'Montres de Luxe', nameAr: 'ساعات فاخرة' }
        ]
      },
      'accessories': {
        name: 'Accessoires',
        nameAr: 'الإكسسوارات',
        types: [
          { key: 'watch-cases', name: 'Étuis Montres', nameAr: 'علب الساعات' },
          { key: 'chains', name: 'Chaînes', nameAr: 'السلاسل' },
          { key: 'jewelry-boxes', name: 'Boîtes Bijoux', nameAr: 'علب المجوهرات' },
          { key: 'jewelry-cleaners', name: 'Nettoyants Bijoux', nameAr: 'منظفات المجوهرات' },
          { key: 'repair-tools', name: 'Outils Réparation', nameAr: 'أدوات الإصلاح' }
        ]
      }
    }
  },
  'pets': {
    name: 'Animaux de Compagnie',
    nameAr: 'الحيوانات الأليفة',
    subcategories: {
      'pet-food': {
        name: 'Alimentation Animaux',
        nameAr: 'طعام الحيوانات',
        types: [
          { key: 'dog-food', name: 'Nourriture Chien', nameAr: 'طعام الكلاب' },
          { key: 'cat-food', name: 'Nourriture Chat', nameAr: 'طعام القطط' },
          { key: 'bird-food', name: 'Nourriture Oiseaux', nameAr: 'طعام الطيور' },
          { key: 'fish-food', name: 'Nourriture Poisson', nameAr: 'طعام الأسماك' },
          { key: 'rabbit-food', name: 'Nourriture Lapin', nameAr: 'طعام الأرانب' },
          { key: 'hamster-food', name: 'Nourriture Hamster', nameAr: 'طعام الهامستر' },
          { key: 'pet-treats', name: 'Friandises', nameAr: 'المكافآت' },
          { key: 'pet-supplements', name: 'Compléments', nameAr: 'المكملات الغذائية' }
        ]
      },
      'pet-care': {
        name: 'Soins Animaux',
        nameAr: 'العناية بالحيوانات',
        types: [
          { key: 'pet-shampoo', name: 'Shampooing', nameAr: 'شامبو الحيوانات' },
          { key: 'pet-toys', name: 'Jouets', nameAr: 'ألعاب الحيوانات' },
          { key: 'pet-beds', name: 'Lits', nameAr: 'أسرّة الحيوانات' },
          { key: 'pet-collars', name: 'Colliers', nameAr: 'أطواق الحيوانات' },
          { key: 'pet-leashes', name: 'Laisse', nameAr: 'أربطة الحيوانات' },
          { key: 'pet-bowls', name: 'Gamelles', nameAr: 'أوعية الطعام' },
          { key: 'pet-litter', name: 'Litière', nameAr: 'فضلات القطط' },
          { key: 'pet-medication', name: 'Médicaments', nameAr: 'أدوية الحيوانات' }
        ]
      }
    }
  },
  'construction-diy': {
    name: 'Construction & Bricolage',
    nameAr: 'البناء والأدوات',
    subcategories: {
      'hand-tools': {
        name: 'Outils à Main',
        nameAr: 'أدوات يدوية',
        types: [
          { key: 'hammers', name: 'Marteaux', nameAr: 'المطارق' },
          { key: 'mallets', name: 'Maillets', nameAr: 'المطارق الخشبية' },
          { key: 'screwdrivers', name: 'Tournevis', nameAr: 'المفكات' },
          { key: 'saws-hand', name: 'Scies à Main', nameAr: 'مناشير يدوية' },
          { key: 'wrenches', name: 'Clés Plates / à Molette', nameAr: 'مفاتيح ربط' },
          { key: 'socket-sets', name: 'Douilles & Cliquets', nameAr: 'طقم مقابس' },
          { key: 'pliers', name: 'Pinces', nameAr: 'الكماشات' },
          { key: 'cutting-pliers', name: 'Pinces Coupantes', nameAr: 'قواطع الأسلاك' },
          { key: 'files-rasps', name: 'Limes & Râpes', nameAr: 'المبردات' },
          { key: 'chisels', name: 'Ciseaux à Bois / Burins', nameAr: 'أزاميل' },
          { key: 'utility-knives', name: 'Cutters / Couteaux', nameAr: 'سكاكين قطع' },
          { key: 'scissors-shears', name: 'Ciseaux & Cisaille', nameAr: 'مقصات' },
          { key: 'crowbars', name: 'Pieds-de-biche', nameAr: 'عتلات' },
          { key: 'clamps', name: 'Serre-joints', nameAr: 'مشابك' },
          { key: 'staplers-tools', name: 'Agrafeuses', nameAr: 'دباسات' },
          { key: 'hex-keys', name: 'Clés Allen', nameAr: 'مفاتيح ألين' }
        ]
      },
      'power-tools': {
        name: 'Outils Électroportatifs',
        nameAr: 'أدوات كهربائية محمولة',
        types: [
          { key: 'drills', name: 'Perceuses', nameAr: 'المثاقب' },
          { key: 'impact-drivers', name: 'Visseuses à Chocs', nameAr: 'مفكات صدم' },
          { key: 'hammer-drills', name: 'Perceuses à Percussion', nameAr: 'مثاقب طرق' },
          { key: 'rotary-hammers', name: 'Perforateurs', nameAr: 'مثاقب هدم' },
          { key: 'angle-grinders', name: 'Meuleuses', nameAr: 'جلاخات' },
          { key: 'circular-saws', name: 'Scies Circulaires', nameAr: 'مناشير دائرية' },
          { key: 'jigsaws', name: 'Scies Sauteuses', nameAr: 'مناشير ترددية' },
          { key: 'reciprocating-saws', name: 'Scies Sabres', nameAr: 'مناشير سيف' },
          { key: 'miter-saws', name: 'Scies à Onglet', nameAr: 'مناشير ميتري' },
          { key: 'table-saws', name: 'Scies sur Table', nameAr: 'مناشير طاولة' },
          { key: 'routers', name: 'Défonceuses / Toupie', nameAr: 'فرايزات' },
          { key: 'sanders', name: 'Ponceuses', nameAr: 'صنفارات' },
          { key: 'planers', name: 'Rabots Électriques', nameAr: 'فارات كهربائية' },
          { key: 'nail-guns', name: 'Cloueuses', nameAr: 'مسدسات مسامير' },
          { key: 'heat-guns', name: 'Décapeurs Thermiques', nameAr: 'مسدسات حرارية' },
          { key: 'multi-tools', name: 'Outils Multifonctions', nameAr: 'أدوات متعددة' },
          { key: 'batteries-chargers', name: 'Batteries & Chargeurs', nameAr: 'بطاريات وشواحن' },
          { key: 'tool-accessories', name: 'Accessoires Outillage', nameAr: 'ملحقات الأدوات' }
        ]
      },
      'measuring-marking': {
        name: 'Mesure & Traçage',
        nameAr: 'القياس والتخطيط',
        types: [
          { key: 'tape-measures', name: 'Mètres Ruban', nameAr: 'أمتار شريط' },
          { key: 'rulers-squares', name: 'Règles & Équerres', nameAr: 'مساطر وزوايا' },
          { key: 'levels', name: 'Niveaux', nameAr: 'موازين الماء' },
          { key: 'laser-levels', name: 'Niveaux Laser', nameAr: 'ليزرات تسوية' },
          { key: 'laser-distance', name: 'Télémètres Laser', nameAr: 'أجهزة قياس ليزر' },
          { key: 'calipers', name: 'Pieds à Coulisse', nameAr: 'قدمة ورنية' },
          { key: 'marking-tools', name: 'Crayons / Traceurs', nameAr: 'أقلام تعليم' },
          { key: 'chalk-lines', name: 'Cordeaux à Tracer', nameAr: 'خيوط تعليم' },
          { key: 'stud-finders', name: 'Détecteurs de Montants', nameAr: 'كاشفات الجدران' },
          { key: 'multimeters', name: 'Multimètres', nameAr: 'أجهزة قياس كهرباء' }
        ]
      },
      'tool-storage-safety': {
        name: 'Rangement & Protection',
        nameAr: 'التخزين والحماية',
        types: [
          { key: 'toolboxes', name: 'Boîtes à Outils', nameAr: 'صناديق أدوات' },
          { key: 'tool-bags', name: 'Sacs à Outils', nameAr: 'حقائب أدوات' },
          { key: 'tool-cabinets', name: 'Armoires Atelier', nameAr: 'خزائن ورشة' },
          { key: 'workbenches', name: 'Établi', nameAr: 'طاولات عمل' },
          { key: 'step-ladders', name: 'Escabeaux', nameAr: 'سلالم منزلية' },
          { key: 'extension-ladders', name: 'Échelles', nameAr: 'سلالم' },
          { key: 'scaffolding', name: 'Échafaudages', nameAr: 'سقالات' },
          { key: 'safety-gloves', name: 'Gants de Protection', nameAr: 'قفازات واقية' },
          { key: 'safety-glasses', name: 'Lunettes de Protection', nameAr: 'نظارات واقية' },
          { key: 'safety-helmets', name: 'Casques', nameAr: 'خوذ' },
          { key: 'ear-protection', name: 'Protection Auditive', nameAr: 'حماية الأذن' },
          { key: 'dust-masks', name: 'Masques / Respirateurs', nameAr: 'كمامات' },
          { key: 'safety-shoes', name: 'Chaussures de Sécurité', nameAr: 'أحذية أمان' },
          { key: 'workwear', name: 'Vêtements de Travail', nameAr: 'ملابس عمل' },
          { key: 'first-aid-kits', name: 'Trousses de Secours', nameAr: 'حقائب إسعاف' }
        ]
      },
      'building-materials': {
        name: 'Matériaux de Construction',
        nameAr: 'مواد البناء',
        types: [
          { key: 'cement', name: 'Ciment', nameAr: 'الإسمنت' },
          { key: 'mortar', name: 'Mortier', nameAr: 'الملاط' },
          { key: 'concrete-mix', name: 'Béton Prêt', nameAr: 'خرسانة جاهزة' },
          { key: 'sand', name: 'Sable', nameAr: 'الرمل' },
          { key: 'gravel', name: 'Gravier', nameAr: 'الحصى' },
          { key: 'bricks', name: 'Briques', nameAr: 'الطوب' },
          { key: 'blocks', name: 'Parpaings / Blocs', nameAr: 'البلوك' },
          { key: 'plaster', name: 'Plâtre', nameAr: 'الجبس' },
          { key: 'plasterboard', name: 'Plaques de Plâtre', nameAr: 'ألواح جبس' },
          { key: 'cement-board', name: 'Plaques Ciment', nameAr: 'ألواح إسمنت' },
          { key: 'rebar', name: 'Ferraillage / Armatures', nameAr: 'حديد التسليح' },
          { key: 'wire-mesh', name: 'Treillis', nameAr: 'شبك حديد' },
          { key: 'lime', name: 'Chaux', nameAr: 'الجير' },
          { key: 'aggregates', name: 'Granulats', nameAr: 'ركام' }
        ]
      },
      'wood-timber': {
        name: 'Bois & Charpente',
        nameAr: 'الخشب والنجارة',
        types: [
          { key: 'lumber', name: 'Bois de Construction', nameAr: 'خشب بناء' },
          { key: 'plywood', name: 'Contreplaqué', nameAr: 'خشب رقائقي' },
          { key: 'osb-mdf', name: 'OSB / MDF', nameAr: 'ألواح OSB / MDF' },
          { key: 'timber-beams', name: 'Poutres / Chevrons', nameAr: 'عوارض خشبية' },
          { key: 'moldings', name: 'Moulures / Plinthes', nameAr: 'قوالب وزوايا' },
          { key: 'wood-panels', name: 'Panneaux Bois', nameAr: 'ألواح خشب' },
          { key: 'decking-wood', name: 'Lames de Terrasse', nameAr: 'ألواح تراس' },
          { key: 'wood-treatment', name: 'Traitement Bois', nameAr: 'معالجة الخشب' },
          { key: 'wood-glue', name: 'Colle à Bois', nameAr: 'غراء خشب' }
        ]
      },
      'metal-profiles': {
        name: 'Métal & Profilés',
        nameAr: 'المعادن والقطاعات',
        types: [
          { key: 'steel-profiles', name: 'Profilés Acier', nameAr: 'قطاعات حديد' },
          { key: 'aluminum-profiles', name: 'Profilés Aluminium', nameAr: 'قطاعات ألمنيوم' },
          { key: 'angle-iron', name: 'Cornières', nameAr: 'زوايا معدنية' },
          { key: 'metal-sheets', name: 'Tôles', nameAr: 'صفائح معدنية' },
          { key: 'metal-mesh', name: 'Grillage Métallique', nameAr: 'شبك معدني' },
          { key: 'metal-rods', name: 'Barres Métalliques', nameAr: 'قضبان معدنية' },
          { key: 'welding-supplies', name: 'Fournitures Soudure', nameAr: 'مستلزمات لحام' }
        ]
      },
      'insulation-roofing': {
        name: 'Isolation & Toiture',
        nameAr: 'العزل والأسقف',
        types: [
          { key: 'thermal-insulation', name: 'Isolation Thermique', nameAr: 'عزل حراري' },
          { key: 'acoustic-insulation', name: 'Isolation Acoustique', nameAr: 'عزل صوتي' },
          { key: 'vapor-barrier', name: 'Pare-vapeur', nameAr: 'حاجز بخار' },
          { key: 'roof-tiles', name: 'Tuiles', nameAr: 'قرميد' },
          { key: 'roof-sheets', name: 'Tôles de Toiture', nameAr: 'صفائح سقف' },
          { key: 'roof-underlay', name: 'Sous-toiture', nameAr: 'طبقة تحت السقف' },
          { key: 'gutters', name: 'Gouttières', nameAr: 'مزاريب' },
          { key: 'downspouts', name: 'Descentes d\'Eau', nameAr: 'أنابيب تصريف' },
          { key: 'flashing', name: 'Solins / Bandes', nameAr: 'شرائط عزل سقف' },
          { key: 'ridge-caps', name: 'Faîtages', nameAr: 'قمة السقف' }
        ]
      },
      'adhesives-sealants': {
        name: 'Colles, Mastics & Joints',
        nameAr: 'الغراء والمعاجين',
        types: [
          { key: 'construction-adhesive', name: 'Colle de Construction', nameAr: 'غراء بناء' },
          { key: 'epoxy', name: 'Époxy', nameAr: 'إيبوكسي' },
          { key: 'contact-cement', name: 'Colle Contact', nameAr: 'غراء تلامس' },
          { key: 'silicone', name: 'Silicone', nameAr: 'سيليكون' },
          { key: 'acrylic-sealant', name: 'Mastic Acrylique', nameAr: 'معجون أكريليك' },
          { key: 'polyurethane-foam', name: 'Mousse PU', nameAr: 'رغوة بولي يوريثان' },
          { key: 'grout-sealant', name: 'Joints Spéciaux', nameAr: 'فواصل خاصة' },
          { key: 'caulk-guns', name: 'Pistolets à Mastic', nameAr: 'مسدسات معجون' },
          { key: 'double-sided-tape', name: 'Ruban Double Face', nameAr: 'شريط لاصق مزدوج' },
          { key: 'duct-tape', name: 'Ruban Adhésif Fort', nameAr: 'شريط لاصق قوي' }
        ]
      },
      'lighting': {
        name: 'Éclairage & Luminaires',
        nameAr: 'الإضاءة والثريات',
        types: [
          { key: 'ceiling-lights', name: 'Plafonniers', nameAr: 'إضاءة السقف' },
          { key: 'flush-mounts', name: 'Encadrés / Encastrés', nameAr: 'إضاءة غاطسة' },
          { key: 'wall-lights', name: 'Appliques Murales', nameAr: 'إضاءة الجدران' },
          { key: 'pendant-lights', name: 'Suspensions', nameAr: 'ثريات معلقة' },
          { key: 'chandeliers', name: 'Lustres', nameAr: 'ثريات' },
          { key: 'floor-lamps', name: 'Lampadaires', nameAr: 'مصابيح أرضية' },
          { key: 'table-lamps', name: 'Lampes de Table', nameAr: 'مصابيح طاولة' },
          { key: 'desk-lamps', name: 'Lampes de Bureau', nameAr: 'مصابيح مكتب' },
          { key: 'spotlights', name: 'Spots', nameAr: 'سبوتات' },
          { key: 'track-lighting', name: 'Éclairage sur Rail', nameAr: 'إضاءة سكة' },
          { key: 'led-strips', name: 'Rubans LED', nameAr: 'شرائط LED' },
          { key: 'led-panels', name: 'Panneaux LED', nameAr: 'ألواح LED' },
          { key: 'downlights', name: 'Downlights', nameAr: 'إضاءة هابطة' },
          { key: 'outdoor-wall-lights', name: 'Appliques Extérieures', nameAr: 'إضاءة جدران خارجية' },
          { key: 'garden-lights', name: 'Bornes / Éclairage Jardin', nameAr: 'إضاءة حديقة' },
          { key: 'floodlights', name: 'Projecteurs', nameAr: 'كشافات' },
          { key: 'solar-lights', name: 'Éclairage Solaire', nameAr: 'إضاءة شمسية' },
          { key: 'motion-lights', name: 'Détecteurs / Éclairage Mouvement', nameAr: 'إضاءة حركة' },
          { key: 'bulbs-led', name: 'Ampoules LED', nameAr: 'مصابيح LED' },
          { key: 'bulbs-halogen', name: 'Ampoules Halogène', nameAr: 'مصابيح هالوجين' },
          { key: 'smart-bulbs', name: 'Ampoules Connectées', nameAr: 'مصابيح ذكية' },
          { key: 'lamp-shades', name: 'Abat-jour', nameAr: 'ظلال المصابيح' },
          { key: 'light-fixtures-parts', name: 'Pièces Luminaires', nameAr: 'قطع إضاءة' }
        ]
      },
      'doors-windows': {
        name: 'Portes & Fenêtres',
        nameAr: 'الأبواب والنوافذ',
        types: [
          { key: 'interior-doors', name: 'Portes Intérieures', nameAr: 'أبواب داخلية' },
          { key: 'exterior-doors', name: 'Portes Extérieures', nameAr: 'أبواب خارجية' },
          { key: 'security-doors', name: 'Portes Blindées', nameAr: 'أبواب مصفحة' },
          { key: 'sliding-doors', name: 'Portes Coulissantes', nameAr: 'أبواب منزلقة' },
          { key: 'folding-doors', name: 'Portes Accordéon / Pliantes', nameAr: 'أبواب قابلة للطي' },
          { key: 'garage-doors', name: 'Portes de Garage', nameAr: 'أبواب مرآب' },
          { key: 'door-frames', name: 'Huisseries / Cadres', nameAr: 'إطارات الأبواب' },
          { key: 'door-thresholds', name: 'Seuils de Porte', nameAr: 'عتبات الأبواب' },
          { key: 'windows', name: 'Fenêtres', nameAr: 'نوافذ' },
          { key: 'window-frames', name: 'Châssis Fenêtres', nameAr: 'إطارات نوافذ' },
          { key: 'sliding-windows', name: 'Fenêtres Coulissantes', nameAr: 'نوافذ منزلقة' },
          { key: 'skylights', name: 'Lucarnes / Velux', nameAr: 'نوافذ سقف' },
          { key: 'shutters', name: 'Volets', nameAr: 'مصاريع' },
          { key: 'roller-shutters', name: 'Volets Roulants', nameAr: 'ستائر دوارة' },
          { key: 'blinds', name: 'Stores', nameAr: 'ستائر' },
          { key: 'insect-screens', name: 'Moustiquaires', nameAr: 'شبك ناموس' },
          { key: 'door-handles', name: 'Poignées de Porte', nameAr: 'مقابض أبواب' },
          { key: 'door-closers', name: 'Ferme-portes', nameAr: 'غالقات أبواب' },
          { key: 'door-stops', name: 'Butées de Porte', nameAr: 'مصدات أبواب' },
          { key: 'weatherstripping', name: 'Joints d\'Étanchéité', nameAr: 'حواجز هواء' }
        ]
      },
      'sanitary-bath': {
        name: 'Sanitaire & Salle de Bain',
        nameAr: 'الصحي وتجهيزات الحمام',
        types: [
          { key: 'toilets', name: 'WC / Toilettes', nameAr: 'مراحيض' },
          { key: 'toilet-seats', name: 'Abattants WC', nameAr: 'مقاعد مرحاض' },
          { key: 'toilet-cisterns', name: 'Réservoirs WC', nameAr: 'خزانات مرحاض' },
          { key: 'bidets', name: 'Bidets', nameAr: 'بيديه' },
          { key: 'urinals', name: 'Urinoirs', nameAr: 'مبولات' },
          { key: 'sinks', name: 'Lavabos', nameAr: 'أحواض غسيل' },
          { key: 'pedestal-sinks', name: 'Lavabos sur Pied', nameAr: 'أحواض بقاعدة' },
          { key: 'countertop-sinks', name: 'Vasques', nameAr: 'أحواض فوق الطاولة' },
          { key: 'bathroom-vanities', name: 'Meubles Lavabo', nameAr: 'أثاث حوض' },
          { key: 'bathtubs', name: 'Baignoires', nameAr: 'أحواض استحمام' },
          { key: 'corner-bathtubs', name: 'Baignoires d\'Angle', nameAr: 'أحواض زاوية' },
          { key: 'whirlpool-tubs', name: 'Baignoires Balnéo', nameAr: 'جاكوزي' },
          { key: 'shower-trays', name: 'Receveurs de Douche', nameAr: 'صواني دش' },
          { key: 'shower-cabins', name: 'Cabines de Douche', nameAr: 'كبائن دش' },
          { key: 'shower-screens', name: 'Parois de Douche', nameAr: 'جدران دش' },
          { key: 'shower-columns', name: 'Colonnes de Douche', nameAr: 'أعمدة دش' },
          { key: 'faucets-basin', name: 'Mitigeurs Lavabo', nameAr: 'خلاطات حوض' },
          { key: 'faucets-bath', name: 'Mitigeurs Bain', nameAr: 'خلاطات حمام' },
          { key: 'faucets-shower', name: 'Mitigeurs Douche', nameAr: 'خلاطات دش' },
          { key: 'shower-heads', name: 'Pommeaux de Douche', nameAr: 'رؤوس دش' },
          { key: 'hand-showers', name: 'Douchettes', nameAr: 'دشات يدوية' },
          { key: 'bathroom-accessories', name: 'Accessoires SDB', nameAr: 'إكسسوارات حمام' },
          { key: 'soap-dishes', name: 'Porte-savon', nameAr: 'حامل صابون' },
          { key: 'toilet-paper-holders', name: 'Porte-papier', nameAr: 'حامل ورق' },
          { key: 'towel-rails', name: 'Porte-serviettes', nameAr: 'حامل مناشف' },
          { key: 'heated-towel-rails', name: 'Sèche-serviettes', nameAr: 'مجفف مناشف' },
          { key: 'mirrors-bathroom', name: 'Miroirs SDB', nameAr: 'مرايا حمام' },
          { key: 'medicine-cabinets', name: 'Armoires de Toilette', nameAr: 'خزائن حمام' },
          { key: 'bathroom-furniture', name: 'Meubles SDB', nameAr: 'أثاث حمام' },
          { key: 'water-heaters', name: 'Chauffe-eau', nameAr: 'سخانات مياه' },
          { key: 'instant-water-heaters', name: 'Chauffe-eau Instantané', nameAr: 'سخان فوري' },
          { key: 'bathroom-scales', name: 'Balances SDB', nameAr: 'موازين حمام' }
        ]
      },
      'kitchen-equipment': {
        name: 'Cuisine Équipée',
        nameAr: 'تجهيزات المطبخ',
        types: [
          { key: 'kitchen-sinks', name: 'Éviers Cuisine', nameAr: 'أحواض مطبخ' },
          { key: 'kitchen-faucets', name: 'Robinets Cuisine', nameAr: 'حنفيات مطبخ' },
          { key: 'kitchen-cabinets', name: 'Meubles Cuisine', nameAr: 'خزائن مطبخ' },
          { key: 'kitchen-worktops', name: 'Plans de Travail', nameAr: 'أسطح عمل' },
          { key: 'kitchen-handles', name: 'Poignées Cuisine', nameAr: 'مقابض مطبخ' },
          { key: 'range-hoods', name: 'Hottes', nameAr: 'شفاطات' },
          { key: 'cooktops', name: 'Plaques de Cuisson', nameAr: 'مواقد' },
          { key: 'built-in-ovens', name: 'Fours Encastrables', nameAr: 'أفران مدمجة' },
          { key: 'kitchen-organizers', name: 'Rangements Cuisine', nameAr: 'منظمات مطبخ' },
          { key: 'splashbacks', name: 'Crédences', nameAr: 'لوحة خلف الحوض' }
        ]
      },
      'plumbing': {
        name: 'Plomberie',
        nameAr: 'السباكة',
        types: [
          { key: 'pipes-pvc', name: 'Tuyaux PVC', nameAr: 'أنابيب PVC' },
          { key: 'pipes-pex', name: 'Tuyaux PER / PEX', nameAr: 'أنابيب PEX' },
          { key: 'pipes-copper', name: 'Tuyaux Cuivre', nameAr: 'أنابيب نحاس' },
          { key: 'pipes-multilayer', name: 'Tuyaux Multicouche', nameAr: 'أنابيب متعددة الطبقات' },
          { key: 'fittings', name: 'Raccords', nameAr: 'وصلات' },
          { key: 'elbows-tees', name: 'Coudes & Tés', nameAr: 'أكواع وتي' },
          { key: 'valves', name: 'Vannes / Robinets d\'arrêt', nameAr: 'صمامات' },
          { key: 'ball-valves', name: 'Vannes à Sphère', nameAr: 'صمامات كروية' },
          { key: 'check-valves', name: 'Clapets Anti-retour', nameAr: 'صمامات لا رجعية' },
          { key: 'pressure-reducers', name: 'Réducteurs de Pression', nameAr: 'مخفضات ضغط' },
          { key: 'pumps', name: 'Pompes', nameAr: 'مضخات' },
          { key: 'booster-pumps', name: 'Surpresseurs', nameAr: 'مضخات تعزيز' },
          { key: 'drainage', name: 'Évacuation / Siphons', nameAr: 'تصريف وسيفون' },
          { key: 'traps', name: 'Siphons', nameAr: 'سيفونات' },
          { key: 'floor-drains', name: 'Avaloirs / Bonde Sol', nameAr: 'مصارف أرضية' },
          { key: 'water-filters', name: 'Filtres à Eau', nameAr: 'فلاتر مياه' },
          { key: 'water-softeners', name: 'Adoucisseurs', nameAr: 'منعمات مياه' },
          { key: 'hose-connectors', name: 'Raccords Flexible', nameAr: 'وصلات خرطوم' },
          { key: 'flexible-hoses', name: 'Flexibles', nameAr: 'خراطيم مرنة' },
          { key: 'pipe-insulation', name: 'Isolation Tuyaux', nameAr: 'عزل أنابيب' },
          { key: 'pipe-clamps', name: 'Colliers de Fixation', nameAr: 'مشابك أنابيب' },
          { key: 'seal-tape', name: 'Ruban Téflon', nameAr: 'شريط تفلون' }
        ]
      },
      'electrical': {
        name: 'Électricité',
        nameAr: 'الكهرباء',
        types: [
          { key: 'cables-wires', name: 'Câbles & Fils', nameAr: 'كابلات وأسلاك' },
          { key: 'cable-trunking', name: 'Goulottes / Chemins de Câbles', nameAr: 'قنوات كابلات' },
          { key: 'conduits', name: 'Conduits / Gaines', nameAr: 'أنابيب حماية' },
          { key: 'sockets', name: 'Prises', nameAr: 'مقابس' },
          { key: 'switches', name: 'Interrupteurs', nameAr: 'مفاتيح' },
          { key: 'dimmers', name: 'Variateurs', nameAr: 'مخفتات' },
          { key: 'switch-plates', name: 'Plaques / Enjoliveurs', nameAr: 'أغطية مفاتيح' },
          { key: 'circuit-breakers', name: 'Disjoncteurs', nameAr: 'قواطع' },
          { key: 'rcd-gfci', name: 'Interrupteurs Différentiels', nameAr: 'قواطع تفاضلية' },
          { key: 'distribution-boards', name: 'Tableaux Électriques', nameAr: 'لوحات توزيع' },
          { key: 'electrical-boxes', name: 'Boîtes Électriques', nameAr: 'علب كهرباء' },
          { key: 'junction-boxes', name: 'Boîtes de Dérivation', nameAr: 'علب توصيل' },
          { key: 'extension-cords', name: 'Rallonges', nameAr: 'أسلاك تمديد' },
          { key: 'power-strips', name: 'Multiprises', nameAr: 'مقابس متعددة' },
          { key: 'transformers', name: 'Transformateurs', nameAr: 'محولات' },
          { key: 'timers', name: 'Programmateur / Minuteries', nameAr: 'مؤقتات' },
          { key: 'motion-sensors', name: 'Détecteurs de Mouvement', nameAr: 'حساسات حركة' },
          { key: 'doorbell-systems', name: 'Sonnettes / Interphones', nameAr: 'أجراس وإنتركوم' },
          { key: 'cable-connectors', name: 'Domino / Connecteurs', nameAr: 'وصلات كابلات' },
          { key: 'electrical-tape', name: 'Ruban Isolant', nameAr: 'شريط عازل' },
          { key: 'generators', name: 'Groupes Électrogènes', nameAr: 'مولدات' },
          { key: 'inverters', name: 'Onduleurs', nameAr: 'محولات عكسية' },
          { key: 'solar-equipment', name: 'Équipement Solaire', nameAr: 'معدات شمسية' }
        ]
      },
      'flooring-tiles': {
        name: 'Sols & Carrelage',
        nameAr: 'الأرضيات والبلاط',
        types: [
          { key: 'ceramic-tiles', name: 'Carrelage Céramique', nameAr: 'بلاط سيراميك' },
          { key: 'porcelain-tiles', name: 'Grès Cérame', nameAr: 'بورسلين' },
          { key: 'floor-tiles', name: 'Carrelage Sol', nameAr: 'بلاط أرضية' },
          { key: 'wall-tiles', name: 'Faïence Murale', nameAr: 'بلاط جدران' },
          { key: 'mosaic-tiles', name: 'Mosaïque', nameAr: 'فسيفساء' },
          { key: 'natural-stone', name: 'Pierre Naturelle', nameAr: 'حجر طبيعي' },
          { key: 'marble-tiles', name: 'Marbre', nameAr: 'رخام' },
          { key: 'laminate', name: 'Stratifié', nameAr: 'أرضيات صناعية' },
          { key: 'parquet', name: 'Parquet', nameAr: 'باركيه' },
          { key: 'engineered-wood', name: 'Parquet Contrecollé', nameAr: 'باركيه مركب' },
          { key: 'vinyl-flooring', name: 'Sol PVC / Vinyle', nameAr: 'فينيل' },
          { key: 'carpet', name: 'Moquette', nameAr: 'موكيت' },
          { key: 'cork-flooring', name: 'Sol Liège', nameAr: 'أرضيات فلين' },
          { key: 'skirting-boards', name: 'Plinthes', nameAr: 'قواعد أرضية' },
          { key: 'transition-strips', name: 'Barres de Seuil', nameAr: 'شرائط انتقال' },
          { key: 'underlayment', name: 'Sous-couche Sol', nameAr: 'طبقة تحت الأرضية' },
          { key: 'tile-adhesive', name: 'Colle Carrelage', nameAr: 'غراء بلاط' },
          { key: 'grout', name: 'Joint Carrelage', nameAr: 'فواصل بلاط' },
          { key: 'tile-spacers', name: 'Croisillons', nameAr: 'فواصل بلاط بلاستيك' },
          { key: 'tile-cutters', name: 'Coupe-carreaux', nameAr: 'قواطع بلاط' },
          { key: 'floor-leveling', name: 'Ragréage / Nivellement', nameAr: 'تسوية أرضية' }
        ]
      },
      'paint-decor': {
        name: 'Peinture & Décoration Murale',
        nameAr: 'الدهان وديكور الجدران',
        types: [
          { key: 'interior-paint', name: 'Peinture Intérieure', nameAr: 'دهان داخلي' },
          { key: 'exterior-paint', name: 'Peinture Extérieure', nameAr: 'دهان خارجي' },
          { key: 'ceiling-paint', name: 'Peinture Plafond', nameAr: 'دهان سقف' },
          { key: 'bathroom-paint', name: 'Peinture Pièces Humides', nameAr: 'دهان رطوبة' },
          { key: 'kitchen-paint', name: 'Peinture Cuisine', nameAr: 'دهان مطبخ' },
          { key: 'primers', name: 'Sous-couches / Primaires', nameAr: 'طبقة أساسية' },
          { key: 'wood-stain', name: 'Lasure / Teinte Bois', nameAr: 'صبغة خشب' },
          { key: 'varnish', name: 'Vernis', nameAr: 'ورنيش' },
          { key: 'metal-paint', name: 'Peinture Métal', nameAr: 'دهان معدن' },
          { key: 'spray-paint', name: 'Peinture Aérosol', nameAr: 'دهان رش' },
          { key: 'wallpaper', name: 'Papier Peint', nameAr: 'ورق جدران' },
          { key: 'wallpaper-paste', name: 'Colle Papier Peint', nameAr: 'غراء ورق جدران' },
          { key: 'wall-panels', name: 'Panneaux Muraux', nameAr: 'ألواح جدران' },
          { key: 'paint-rollers', name: 'Rouleaux', nameAr: 'بكرات' },
          { key: 'paint-brushes', name: 'Pinceaux', nameAr: 'فرش' },
          { key: 'paint-trays', name: 'Bacs à Peinture', nameAr: 'أوعية دهان' },
          { key: 'masking-tape', name: 'Ruban de Masquage', nameAr: 'شريط تغطية' },
          { key: 'drop-cloths', name: 'Bâches de Protection', nameAr: 'أغطية حماية' },
          { key: 'sandpaper', name: 'Papiers Abrasifs', nameAr: 'ورق صنفرة' },
          { key: 'fillers', name: 'Enduits / Reboucheurs', nameAr: 'معاجين ترميم' },
          { key: 'paint-removers', name: 'Décapants', nameAr: 'مزيلات دهان' }
        ]
      },
      'heating-climate': {
        name: 'Chauffage & Climatisation',
        nameAr: 'التدفئة والتكييف',
        types: [
          { key: 'radiators', name: 'Radiateurs', nameAr: 'مشعات' },
          { key: 'electric-heaters', name: 'Chauffages Électriques', nameAr: 'دفايات كهربائية' },
          { key: 'oil-heaters', name: 'Radiateurs à Bain d\'Huile', nameAr: 'دفايات زيت' },
          { key: 'fan-heaters', name: 'Chauffages Soufflants', nameAr: 'دفايات مروحة' },
          { key: 'infrared-heaters', name: 'Chauffages Infrarouges', nameAr: 'دفايات أشعة تحت حمراء' },
          { key: 'thermostats', name: 'Thermostats', nameAr: 'ترموستات' },
          { key: 'air-conditioners', name: 'Climatiseurs', nameAr: 'مكيفات' },
          { key: 'fans', name: 'Ventilateurs', nameAr: 'مراوح' },
          { key: 'ceiling-fans', name: 'Ventilateurs de Plafond', nameAr: 'مراوح سقف' },
          { key: 'dehumidifiers', name: 'Déshumidificateurs', nameAr: 'مزيلات رطوبة' },
          { key: 'humidifiers', name: 'Humidificateurs', nameAr: 'مرطبات هواء' },
          { key: 'air-purifiers', name: 'Purificateurs d\'Air', nameAr: 'منقيات هواء' },
          { key: 'chimney-accessories', name: 'Accessoires Cheminée', nameAr: 'ملحقات مدفأة' },
          { key: 'pellet-stoves', name: 'Poêles à Granulés', nameAr: 'مواقد حبيبات' }
        ]
      },
      'storage-organization': {
        name: 'Rangement & Organisation',
        nameAr: 'التخزين والتنظيم',
        types: [
          { key: 'shelving-units', name: 'Étagères Modulaires', nameAr: 'أرفف معيارية' },
          { key: 'storage-cabinets', name: 'Armoires de Rangement', nameAr: 'خزائن تخزين' },
          { key: 'wall-hooks-racks', name: 'Crochets & Supports Muraux', nameAr: 'خطافات جدارية' },
          { key: 'storage-boxes', name: 'Boîtes de Rangement', nameAr: 'صناديق تخزين' },
          { key: 'garage-storage', name: 'Rangement Garage', nameAr: 'تخزين مرآب' },
          { key: 'closet-systems', name: 'Systèmes Placard', nameAr: 'أنظمة خزانة' },
          { key: 'pegboards', name: 'Panneaux Perforés', nameAr: 'ألواح مثقبة' }
        ]
      },
      'security-access': {
        name: 'Sécurité & Accès',
        nameAr: 'الأمن والدخول',
        types: [
          { key: 'alarm-systems', name: 'Systèmes d\'Alarme', nameAr: 'أنظمة إنذار' },
          { key: 'security-cameras', name: 'Caméras de Surveillance', nameAr: 'كاميرات مراقبة' },
          { key: 'door-viewers', name: 'Judas de Porte', nameAr: 'عين الباب' },
          { key: 'safes', name: 'Coffres-forts', nameAr: 'خزائن حديدية' },
          { key: 'smoke-detectors', name: 'Détecteurs de Fumée', nameAr: 'كاشفات دخان' },
          { key: 'co-detectors', name: 'Détecteurs CO', nameAr: 'كاشفات أول أكسيد الكربون' },
          { key: 'fire-extinguishers', name: 'Extincteurs', nameAr: 'طفايات حريق' },
          { key: 'fire-blankets', name: 'Couvertures Anti-feu', nameAr: 'بطانيات حريق' },
          { key: 'access-control', name: 'Contrôle d\'Accès', nameAr: 'تحكم بالدخول' }
        ]
      }
    }
  },
  'restaurant-hotel': {
    name: 'Restauration & Hôtellerie',
    nameAr: 'المطاعم والفنادق',
    subcategories: {
      'restaurant-supplies': {
        name: 'Fournitures Restaurant',
        nameAr: 'مستلزمات المطعم',
        types: [
          { key: 'tableware', name: 'Vaisselle', nameAr: 'أدوات المائدة' },
          { key: 'cutlery', name: 'Couverts', nameAr: 'أدوات الطعام' },
          { key: 'glassware', name: 'Verres', nameAr: 'الأكواب الزجاجية' },
          { key: 'napkins', name: 'Serviettes', nameAr: 'المناديل' },
          { key: 'tablecloths', name: 'Nappes', nameAr: 'مفارش الطاولة' },
          { key: 'cooking-equipment', name: 'Équipement Cuisine', nameAr: 'معدات المطبخ' },
          { key: 'food-containers', name: 'Contenants', nameAr: 'الحاويات' }
        ]
      },
      'hotel-supplies': {
        name: 'Fournitures Hôtel',
        nameAr: 'مستلزمات الفندق',
        types: [
          { key: 'bedding', name: 'Literie', nameAr: 'أغطية الأسرة' },
          { key: 'towels', name: 'Serviettes', nameAr: 'المناشف' },
          { key: 'amenities', name: 'Articles de Toilette', nameAr: 'مستلزمات الحمام' },
          { key: 'cleaning-supplies', name: 'Produits Nettoyage', nameAr: 'منتجات التنظيف' }
        ]
      }
    }
  },
  'textiles-fabrics': {
    name: 'Textiles & Tissus',
    nameAr: 'المنسوجات والأقمشة',
    subcategories: {
      'fabrics': {
        name: 'Tissus',
        nameAr: 'الأقمشة',
        types: [
          { key: 'cotton', name: 'Coton', nameAr: 'القطن' },
          { key: 'silk', name: 'Soie', nameAr: 'الحرير' },
          { key: 'wool', name: 'Laine', nameAr: 'الصوف' },
          { key: 'linen', name: 'Lin', nameAr: 'الكتان' },
          { key: 'polyester', name: 'Polyester', nameAr: 'البوليستر' },
          { key: 'denim', name: 'Jean', nameAr: 'الجينز' },
          { key: 'leather', name: 'Cuir', nameAr: 'الجلد' },
          { key: 'synthetic', name: 'Synthétique', nameAr: 'الاصطناعي' }
        ]
      },
      'sewing-supplies': {
        name: 'Fournitures Couture',
        nameAr: 'مستلزمات الخياطة',
        types: [
          { key: 'thread', name: 'Fil', nameAr: 'الخيط' },
          { key: 'needles', name: 'Aiguilles', nameAr: 'الإبر' },
          { key: 'buttons', name: 'Boutons', nameAr: 'الأزرار' },
          { key: 'zippers', name: 'Fermetures Éclair', nameAr: 'السحابات' },
          { key: 'scissors', name: 'Ciseaux', nameAr: 'المقص' },
          { key: 'patterns', name: 'Patrons', nameAr: 'أنماط الخياطة' }
        ]
      }
    }
  },
  'hardware': {
    name: 'Quincaillerie',
    nameAr: 'العدد والأدوات المعدنية',
    subcategories: {
      'fasteners': {
        name: 'Fixations',
        nameAr: 'المثبتات',
        types: [
          { key: 'screws', name: 'Vis', nameAr: 'البراغي' },
          { key: 'wood-screws', name: 'Vis à Bois', nameAr: 'براغي خشب' },
          { key: 'machine-screws', name: 'Vis Métriques', nameAr: 'براغي مترية' },
          { key: 'self-tapping-screws', name: 'Vis Autotaraudeuses', nameAr: 'براغي ذاتية اللولبة' },
          { key: 'drywall-screws', name: 'Vis Placo', nameAr: 'براغي جبس' },
          { key: 'nails', name: 'Clous', nameAr: 'المسامير' },
          { key: 'brad-nails', name: 'Pointes', nameAr: 'مسامير رفيعة' },
          { key: 'bolts', name: 'Boulons', nameAr: 'البراغي الكبيرة' },
          { key: 'nuts', name: 'Écrous', nameAr: 'صواميل' },
          { key: 'washers', name: 'Rondelles', nameAr: 'الحلقات' },
          { key: 'anchors', name: 'Chevilles', nameAr: 'المرابط' },
          { key: 'wall-plugs', name: 'Chevilles Mur', nameAr: 'مرابط جدار' },
          { key: 'chemical-anchors', name: 'Scellement Chimique', nameAr: 'تثبيت كيميائي' },
          { key: 'hooks', name: 'Crochets', nameAr: 'الخطافات' },
          { key: 'eye-bolts', name: 'Pitons / Anneaux', nameAr: 'حلقات تثبيت' },
          { key: 'rivets', name: 'Rivets', nameAr: 'المسامير البرشام' },
          { key: 'cable-ties', name: 'Colliers de Serrage', nameAr: 'أربطة الكابلات' },
          { key: 'staples', name: 'Agrafes', nameAr: 'دبابيس' },
          { key: 'threaded-rods', name: 'Tiges Filetées', nameAr: 'قضبان ملولبة' }
        ]
      },
      'locks': {
        name: 'Serrurerie',
        nameAr: 'الأقفال',
        types: [
          { key: 'door-locks', name: 'Serrures Porte', nameAr: 'أقفال الأبواب' },
          { key: 'mortise-locks', name: 'Serrures Encastrées', nameAr: 'أقفال غاطسة' },
          { key: 'rim-locks', name: 'Serrures en Applique', nameAr: 'أقفال سطحية' },
          { key: 'padlocks', name: 'Cadenas', nameAr: 'الأقفال المعلقة' },
          { key: 'combination-locks', name: 'Cadenas à Code', nameAr: 'أقفال برمز' },
          { key: 'keys', name: 'Clés', nameAr: 'المفاتيح' },
          { key: 'key-blanks', name: 'Ébauches de Clés', nameAr: 'مفاتيح خام' },
          { key: 'hinges', name: 'Paumelles / Charnières', nameAr: 'المفصلات' },
          { key: 'piano-hinges', name: 'Charnières Continues', nameAr: 'مفصلات طويلة' },
          { key: 'cylinders', name: 'Cylindres', nameAr: 'أسطوانات الأقفال' },
          { key: 'security-chains', name: 'Chaînes de Sécurité', nameAr: 'سلاسل الأمان' },
          { key: 'latches-bolts', name: 'Loquets / Verrous', nameAr: 'مزالج' },
          { key: 'cabinet-locks', name: 'Serrures Meuble', nameAr: 'أقفال أثاث' },
          { key: 'window-locks', name: 'Serrures Fenêtre', nameAr: 'أقفال نوافذ' }
        ]
      },
      'furniture-hardware': {
        name: 'Quincaillerie Meuble',
        nameAr: 'عدد الأثاث',
        types: [
          { key: 'handles', name: 'Poignées', nameAr: 'المقابض' },
          { key: 'knobs', name: 'Boutons', nameAr: 'المقابض الدائرية' },
          { key: 'drawer-slides', name: 'Glissières Tiroir', nameAr: 'سكك أدراج' },
          { key: 'cabinet-hinges', name: 'Charnières Meuble', nameAr: 'مفصلات أثاث' },
          { key: 'soft-close', name: 'Amortisseurs / Soft-close', nameAr: 'إغلاق ناعم' },
          { key: 'shelf-supports', name: 'Supports d\'Étagère', nameAr: 'دعامات أرفف' },
          { key: 'connectors-furniture', name: 'Assemblages Meuble', nameAr: 'وصلات أثاث' },
          { key: 'casters', name: 'Roulettes', nameAr: 'العجلات' },
          { key: 'furniture-feet', name: 'Pieds de Meuble', nameAr: 'أرجل أثاث' },
          { key: 'magnetic-catches', name: 'Aimants / Fermetures', nameAr: 'مغناطيس إغلاق' }
        ]
      },
      'hardware-accessories': {
        name: 'Accessoires Quincaillerie',
        nameAr: 'إكسسوارات العدد',
        types: [
          { key: 'brackets', name: 'Équerres / Supports', nameAr: 'الزوايا والدعامات' },
          { key: 'corner-braces', name: 'Équerres d\'Angle', nameAr: 'زوايا تثبيت' },
          { key: 'rope-chain', name: 'Cordes & Chaînes', nameAr: 'الحبال والسلاسل' },
          { key: 'wire-cable', name: 'Câbles Acier / Fils', nameAr: 'كابلات حديد' },
          { key: 'tapes-glues', name: 'Rubans & Colles', nameAr: 'الأشرطة والغراء' },
          { key: 'springs', name: 'Ressorts', nameAr: 'نوابض' },
          { key: 'rubber-feet', name: 'Patins / Tampons', nameAr: 'وسائد مطاطية' },
          { key: 'grommets', name: 'Passes-câbles', nameAr: 'فتحات كابلات' },
          { key: 'nameplates', name: 'Plaques / Numéros', nameAr: 'لوحات وأرقام' },
          { key: 'letterbox-parts', name: 'Accessoires Boîte aux Lettres', nameAr: 'ملحقات صندوق بريد' }
        ]
      },
      'abrasives-cutting': {
        name: 'Abrasifs & Coupe',
        nameAr: 'مواد كاشطة وقطع',
        types: [
          { key: 'sandpaper-sheets', name: 'Papiers de Verre', nameAr: 'ورق صنفرة' },
          { key: 'sanding-discs', name: 'Disques Abrasifs', nameAr: 'أقراص صنفرة' },
          { key: 'cutting-discs', name: 'Disques à Tronçonner', nameAr: 'أقراص قطع' },
          { key: 'grinding-wheels', name: 'Meules', nameAr: 'أحجار جلخ' },
          { key: 'saw-blades', name: 'Lames de Scie', nameAr: 'شفرات منشار' },
          { key: 'drill-bits', name: 'Forets', nameAr: 'لقم مثقاب' },
          { key: 'masonry-bits', name: 'Forets Béton', nameAr: 'لقم خرسانة' },
          { key: 'hole-saws', name: 'Scies Cloches', nameAr: 'مناشير ثقوب' },
          { key: 'router-bits', name: 'Fraises', nameAr: 'لقم فرايز' },
          { key: 'cutting-fluids', name: 'Lubrifiants Coupe', nameAr: 'زيوت قطع' }
        ]
      }
    }
  },
  'toys-games': {
    name: 'Jouets & Jeux',
    nameAr: 'الألعاب والألعاب',
    subcategories: {
      'board-games': {
        name: 'Jeux de Société',
        nameAr: 'ألعاب الطاولة',
        types: [
          { key: 'chess', name: 'Échecs', nameAr: 'الشطرنج' },
          { key: 'checkers', name: 'Dames', nameAr: 'الداما' },
          { key: 'monopoly', name: 'Monopoly', nameAr: 'المونوبولي' },
          { key: 'cards', name: 'Cartes', nameAr: 'البطاقات' },
          { key: 'puzzles', name: 'Puzzles', nameAr: 'الألغاز' }
        ]
      },
      'educational-toys': {
        name: 'Jouets Éducatifs',
        nameAr: 'الألعاب التعليمية',
        types: [
          { key: 'building-blocks', name: 'Blocs Construction', nameAr: 'مكعبات البناء' },
          { key: 'science-kits', name: 'Kits Scientifiques', nameAr: 'مجموعات العلوم' },
          { key: 'musical-toys', name: 'Jouets Musicaux', nameAr: 'الألعاب الموسيقية' },
          { key: 'art-supplies', name: 'Fournitures Art', nameAr: 'مستلزمات الفن' }
        ]
      }
    }
  },
  'flowers-plants': {
    name: 'Fleurs & Plantes',
    nameAr: 'الزهور والنباتات',
    subcategories: {
      'flowers': {
        name: 'Fleurs',
        nameAr: 'الزهور',
        types: [
          { key: 'roses', name: 'Roses', nameAr: 'الورود' },
          { key: 'tulips', name: 'Tulipes', nameAr: 'الزنبق' },
          { key: 'lilies', name: 'Lys', nameAr: 'الزنابق' },
          { key: 'orchids', name: 'Orchidées', nameAr: 'الأوركيد' },
          { key: 'sunflowers', name: 'Tournesols', nameAr: 'عباد الشمس' },
          { key: 'carnations', name: 'Œillets', nameAr: 'القرنفل' },
          { key: 'bouquets', name: 'Bouquets', nameAr: 'باقات' },
          { key: 'seasonal-flowers', name: 'Fleurs de Saison', nameAr: 'زهور الموسم' }
        ]
      },
      'plants': {
        name: 'Plantes',
        nameAr: 'النباتات',
        types: [
          { key: 'indoor-plants', name: 'Plantes Intérieur', nameAr: 'نباتات داخلية' },
          { key: 'outdoor-plants', name: 'Plantes Extérieur', nameAr: 'نباتات خارجية' },
          { key: 'herbs', name: 'Herbes Aromatiques', nameAr: 'أعشاب عطرية' },
          { key: 'succulents', name: 'Plantes Grasses', nameAr: 'النباتات العصارية' },
          { key: 'cacti', name: 'Cactus', nameAr: 'صبار' },
          { key: 'shrubs', name: 'Arbustes', nameAr: 'شجيرات' },
          { key: 'trees', name: 'Arbres', nameAr: 'أشجار' },
          { key: 'lawn-turf', name: 'Gazon / Pelouse', nameAr: 'عشب' },
          { key: 'seeds', name: 'Graines', nameAr: 'البذور' },
          { key: 'bulbs', name: 'Bulbes', nameAr: 'أبصال' },
          { key: 'fertilizer', name: 'Engrais', nameAr: 'السماد' },
          { key: 'plant-food', name: 'Nutriments Plantes', nameAr: 'مغذيات نباتات' },
          { key: 'pots', name: 'Pots', nameAr: 'الأصص' },
          { key: 'hanging-baskets', name: 'Paniers Suspendus', nameAr: 'سلال معلقة' },
          { key: 'plant-supports', name: 'Tuteurs / Supports', nameAr: 'دعامات نباتات' }
        ]
      },
      'garden-center': {
        name: 'Centre Jardin',
        nameAr: 'مستلزمات الحديقة',
        types: [
          { key: 'potting-soil', name: 'Terreau Rempotage', nameAr: 'تربة زراعة' },
          { key: 'mulch', name: 'Paillis', nameAr: 'نشارة' },
          { key: 'pest-spray', name: 'Traitements Plantes', nameAr: 'معالجات نباتات' },
          { key: 'watering-tools', name: 'Outils Arrosage', nameAr: 'أدوات ري' },
          { key: 'greenhouse-kits', name: 'Serres / Mini-serres', nameAr: 'بيوت بلاستيكية' }
        ]
      }
    }
  },
  'music-instruments': {
    name: 'Instruments de Musique',
    nameAr: 'الآلات الموسيقية',
    subcategories: {
      'instruments': {
        name: 'Instruments',
        nameAr: 'الآلات',
        types: [
          { key: 'guitars', name: 'Guitares', nameAr: 'القيثارات' },
          { key: 'pianos', name: 'Pianos', nameAr: 'البيانو' },
          { key: 'drums', name: 'Batteries', nameAr: 'الطبول' },
          { key: 'violins', name: 'Violons', nameAr: 'الكمان' },
          { key: 'flutes', name: 'Flûtes', nameAr: 'الناي' },
          { key: 'trumpets', name: 'Trompettes', nameAr: 'البوق' },
          { key: 'traditional-instruments', name: 'Instruments Traditionnels', nameAr: 'الآلات التقليدية' }
        ]
      },
      'accessories': {
        name: 'Accessoires',
        nameAr: 'الملحقات',
        types: [
          { key: 'strings', name: 'Cordes', nameAr: 'الأوتار' },
          { key: 'cases', name: 'Étuis', nameAr: 'الحقائب' },
          { key: 'stands', name: 'Pieds', nameAr: 'الحوامل' },
          { key: 'microphones', name: 'Microphones', nameAr: 'الميكروفونات' },
          { key: 'amplifiers', name: 'Amplificateurs', nameAr: 'المكبرات' }
        ]
      }
    }
  },
  'art-crafts': {
    name: 'Art & Loisirs Créatifs',
    nameAr: 'الفن والحرف اليدوية',
    subcategories: {
      'art-supplies': {
        name: 'Fournitures Art',
        nameAr: 'مستلزمات الفن',
        types: [
          { key: 'paints', name: 'Peintures', nameAr: 'الألوان' },
          { key: 'brushes', name: 'Pinceaux', nameAr: 'الفرش' },
          { key: 'canvas', name: 'Toiles', nameAr: 'اللوحات' },
          { key: 'sketchbooks', name: 'Carnets Dessin', nameAr: 'دفاتر الرسم' },
          { key: 'pencils', name: 'Crayons', nameAr: 'أقلام الرصاص' },
          { key: 'markers', name: 'Marqueurs', nameAr: 'أقلام التحديد' },
          { key: 'clay', name: 'Argile', nameAr: 'الطين' },
          { key: 'sculpting-tools', name: 'Outils Sculpture', nameAr: 'أدوات النحت' }
        ]
      },
      'craft-supplies': {
        name: 'Fournitures Bricolage',
        nameAr: 'مستلزمات الحرف',
        types: [
          { key: 'beads', name: 'Perles', nameAr: 'الخرز' },
          { key: 'yarn', name: 'Laine', nameAr: 'الخيوط' },
          { key: 'fabric', name: 'Tissu', nameAr: 'القماش' },
          { key: 'ribbons', name: 'Rubans', nameAr: 'الأشرطة' },
          { key: 'glue', name: 'Colle', nameAr: 'الصمغ' },
          { key: 'scissors', name: 'Ciseaux', nameAr: 'المقص' }
        ]
      }
    }
  },
  'vehicles-motorcycles': {
    name: 'Véhicules & Motos',
    nameAr: 'المركبات والدراجات النارية',
    subcategories: {
      'vehicles': {
        name: 'Véhicules',
        nameAr: 'المركبات',
        types: [
          { key: 'cars', name: 'Voitures', nameAr: 'السيارات' },
          { key: 'trucks', name: 'Camions', nameAr: 'الشاحنات' },
          { key: 'vans', name: 'Fourgonnettes', nameAr: 'الحافلات الصغيرة' },
          { key: 'motorcycles', name: 'Motos', nameAr: 'الدراجات النارية' },
          { key: 'scooters', name: 'Scooters', nameAr: 'السكوتر' },
          { key: 'bicycles', name: 'Vélos', nameAr: 'الدراجات الهوائية' }
        ]
      },
      'parts': {
        name: 'Pièces',
        nameAr: 'القطع',
        types: [
          { key: 'engines', name: 'Moteurs', nameAr: 'المحركات' },
          { key: 'transmissions', name: 'Transmissions', nameAr: 'ناقل الحركة' },
          { key: 'brakes', name: 'Freins', nameAr: 'الفرامل' },
          { key: 'suspension', name: 'Suspension', nameAr: 'التعليق' },
          { key: 'exhaust', name: 'Échappement', nameAr: 'العادم' }
        ]
      }
    }
  },
  'medical-equipment': {
    name: 'Matériel Médical',
    nameAr: 'المعدات الطبية',
    subcategories: {
      'equipment': {
        name: 'Équipement',
        nameAr: 'المعدات',
        types: [
          { key: 'hospital-beds', name: 'Lits Médicaux', nameAr: 'الأسرّة الطبية' },
          { key: 'wheelchairs', name: 'Fauteuils Roulants', nameAr: 'الكراسي المتحركة' },
          { key: 'stretchers', name: 'Brancards', nameAr: 'النقالات' },
          { key: 'monitors', name: 'Moniteurs', nameAr: 'الشاشات الطبية' },
          { key: 'ventilators', name: 'Ventilateurs', nameAr: 'أجهزة التنفس' },
          { key: 'defibrillators', name: 'Défibrillateurs', nameAr: 'أجهزة الإنعاش' }
        ]
      },
      'supplies': {
        name: 'Fournitures',
        nameAr: 'المستلزمات',
        types: [
          { key: 'syringes', name: 'Seringues', nameAr: 'الحقن' },
          { key: 'bandages', name: 'Bandages', nameAr: 'الضمادات' },
          { key: 'gloves', name: 'Gants', nameAr: 'القفازات' },
          { key: 'masks', name: 'Masques', nameAr: 'الأقنعة' },
          { key: 'gowns', name: 'Blouses', nameAr: 'المعاطف الطبية' }
        ]
      }
    }
  },
  'cosmetics-beauty': {
    name: 'Cosmétiques & Beauté',
    nameAr: 'مستحضرات التجميل والجمال',
    subcategories: {
      'makeup': {
        name: 'Maquillage',
        nameAr: 'المكياج',
        types: [
          { key: 'foundation', name: 'Fond de Teint', nameAr: 'كريم الأساس' },
          { key: 'concealer', name: 'Anti-cernes', nameAr: 'مخفي العيوب' },
          { key: 'powder', name: 'Poudre', nameAr: 'البودرة' },
          { key: 'blush', name: 'Fard à Joues', nameAr: 'أحمر الخدود' },
          { key: 'eyeshadow', name: 'Fard à Paupières', nameAr: 'ظلال العيون' },
          { key: 'mascara', name: 'Mascara', nameAr: 'الماسكارا' },
          { key: 'eyeliner', name: 'Crayon Yeux', nameAr: 'كحل العيون' },
          { key: 'lipstick', name: 'Rouge à Lèvres', nameAr: 'أحمر الشفاه' },
          { key: 'lip-gloss', name: 'Brillant à Lèvres', nameAr: 'لمعان الشفاه' },
          { key: 'nail-polish', name: 'Vernis à Ongles', nameAr: 'طلاء الأظافر' }
        ]
      },
      'skincare': {
        name: 'Soins Peau',
        nameAr: 'العناية بالبشرة',
        types: [
          { key: 'cleansers', name: 'Nettoyants', nameAr: 'المنظفات' },
          { key: 'toners', name: 'Toniques', nameAr: 'التونر' },
          { key: 'serums', name: 'Sérums', nameAr: 'السيروم' },
          { key: 'moisturizers', name: 'Hydratants', nameAr: 'المرطبات' },
          { key: 'sunscreen', name: 'Crème Solaire', nameAr: 'واقي الشمس' },
          { key: 'face-masks', name: 'Masques Visage', nameAr: 'أقنعة الوجه' },
          { key: 'exfoliants', name: 'Exfoliants', nameAr: 'المقشرات' },
          { key: 'anti-aging', name: 'Anti-âge', nameAr: 'مضاد الشيخوخة' }
        ]
      }
    }
  },
  'specialty-dairy': {
    name: 'Produits Laitiers Spécialisés',
    nameAr: 'منتجات الألبان المتخصصة',
    subcategories: {
      'cheese': {
        name: 'Fromages',
        nameAr: 'الأجبان',
        types: [
          { key: 'artisan-cheese', name: 'Fromage Artisanal', nameAr: 'الجبن الحرفي' },
          { key: 'aged-cheese', name: 'Fromage Affiné', nameAr: 'الجبن المعتق' },
          { key: 'soft-cheese', name: 'Fromage à Pâte Molle', nameAr: 'الجبن الطري' },
          { key: 'hard-cheese', name: 'Fromage à Pâte Dure', nameAr: 'الجبن الصلب' },
          { key: 'blue-cheese', name: 'Fromage Bleu', nameAr: 'الجبن الأزرق' },
          { key: 'goat-cheese', name: 'Fromage de Chèvre', nameAr: 'جبن الماعز' },
          { key: 'sheep-cheese', name: 'Fromage de Brebis', nameAr: 'جبن الأغنام' }
        ]
      },
      'yogurt': {
        name: 'Yaourts',
        nameAr: 'الزبادي',
        types: [
          { key: 'greek-yogurt', name: 'Yaourt Grec', nameAr: 'الزبادي اليوناني' },
          { key: 'probiotic-yogurt', name: 'Yaourt Probiotique', nameAr: 'الزبادي البروبيوتيك' },
          { key: 'flavored-yogurt', name: 'Yaourt Aromatisé', nameAr: 'الزبادي المنكه' },
          { key: 'organic-yogurt', name: 'Yaourt Bio', nameAr: 'الزبادي العضوي' }
        ]
      }
    }
  },
  'gourmet-food': {
    name: 'Épicerie Fine',
    nameAr: 'البقالة الفاخرة',
    subcategories: {
      'specialty-foods': {
        name: 'Produits Spéciaux',
        nameAr: 'المنتجات الخاصة',
        types: [
          { key: 'truffles', name: 'Truffes', nameAr: 'الكمأة' },
          { key: 'caviar', name: 'Caviar', nameAr: 'الكافيار' },
          { key: 'foie-gras', name: 'Foie Gras', nameAr: 'كبد الأوز' },
          { key: 'olive-oil-premium', name: 'Huile d\'Olive Premium', nameAr: 'زيت الزيتون الفاخر' },
          { key: 'balsamic-vinegar', name: 'Vinaigre Balsamique', nameAr: 'الخل البلسمي' },
          { key: 'specialty-coffee', name: 'Café Spécialisé', nameAr: 'القهوة المتخصصة' },
          { key: 'artisan-chocolate', name: 'Chocolat Artisanal', nameAr: 'الشوكولاتة الحرفية' },
          { key: 'aged-cheese', name: 'Fromage Affiné', nameAr: 'الجبن المعتق' }
        ]
      },
      'imported-foods': {
        name: 'Produits Importés',
        nameAr: 'المنتجات المستوردة',
        types: [
          { key: 'italian-products', name: 'Produits Italiens', nameAr: 'المنتجات الإيطالية' },
          { key: 'french-products', name: 'Produits Français', nameAr: 'المنتجات الفرنسية' },
          { key: 'spanish-products', name: 'Produits Espagnols', nameAr: 'المنتجات الإسبانية' },
          { key: 'asian-products', name: 'Produits Asiatiques', nameAr: 'المنتجات الآسيوية' }
        ]
      }
    }
  },
  'alcoholic-beverages': {
    name: 'Boissons Alcoolisées',
    nameAr: 'المشروبات الكحولية',
    subcategories: {
      'wine': {
        name: 'Vin',
        nameAr: 'النبيذ',
        types: [
          { key: 'red-wine', name: 'Vin Rouge', nameAr: 'النبيذ الأحمر' },
          { key: 'white-wine', name: 'Vin Blanc', nameAr: 'النبيذ الأبيض' },
          { key: 'rose-wine', name: 'Vin Rosé', nameAr: 'النبيذ الوردي' },
          { key: 'sparkling-wine', name: 'Vin Mousseux', nameAr: 'النبيذ الفوار' },
          { key: 'champagne', name: 'Champagne', nameAr: 'الشمبانيا' }
        ]
      },
      'spirits': {
        name: 'Spiritueux',
        nameAr: 'المشروبات الروحية',
        types: [
          { key: 'whiskey', name: 'Whisky', nameAr: 'الويسكي' },
          { key: 'vodka', name: 'Vodka', nameAr: 'الفودكا' },
          { key: 'rum', name: 'Rhum', nameAr: 'الروم' },
          { key: 'gin', name: 'Gin', nameAr: 'الجين' },
          { key: 'tequila', name: 'Téquila', nameAr: 'التكيلا' },
          { key: 'cognac', name: 'Cognac', nameAr: 'الكونياك' },
          { key: 'brandy', name: 'Brandy', nameAr: 'البراندي' }
        ]
      },
      'beer': {
        name: 'Bière',
        nameAr: 'البيرة',
        types: [
          { key: 'lager', name: 'Bière Blonde', nameAr: 'البيرة الفاتحة' },
          { key: 'ale', name: 'Bière Ambrée', nameAr: 'البيرة الكهرمانية' },
          { key: 'stout', name: 'Bière Brune', nameAr: 'البيرة الداكنة' },
          { key: 'craft-beer', name: 'Bière Artisanale', nameAr: 'البيرة الحرفية' }
        ]
      }
    }
  },
  'gluten-free': {
    name: 'Produits Sans Gluten',
    nameAr: 'المنتجات الخالية من الغلوتين',
    subcategories: {
      'food': {
        name: 'Aliments',
        nameAr: 'الأطعمة',
        types: [
          { key: 'gluten-free-bread', name: 'Pain Sans Gluten', nameAr: 'خبز خال من الغلوتين' },
          { key: 'gluten-free-pasta', name: 'Pâtes Sans Gluten', nameAr: 'معكرونة خالية من الغلوتين' },
          { key: 'gluten-free-flour', name: 'Farine Sans Gluten', nameAr: 'دقيق خال من الغلوتين' },
          { key: 'gluten-free-cookies', name: 'Biscuits Sans Gluten', nameAr: 'بسكويت خال من الغلوتين' },
          { key: 'gluten-free-cereals', name: 'Céréales Sans Gluten', nameAr: 'حبوب خالية من الغلوتين' }
        ]
      }
    }
  },
  'organic-products': {
    name: 'Produits Bio',
    nameAr: 'المنتجات العضوية',
    subcategories: {
      'organic-food': {
        name: 'Aliments Bio',
        nameAr: 'الأطعمة العضوية',
        types: [
          { key: 'organic-fruits', name: 'Fruits Bio', nameAr: 'فواكه عضوية' },
          { key: 'organic-vegetables', name: 'Légumes Bio', nameAr: 'خضار عضوية' },
          { key: 'organic-meat', name: 'Viande Bio', nameAr: 'لحم عضوي' },
          { key: 'organic-dairy', name: 'Produits Laitiers Bio', nameAr: 'منتجات ألبان عضوية' },
          { key: 'organic-grains', name: 'Céréales Bio', nameAr: 'حبوب عضوية' }
        ]
      },
      'organic-care': {
        name: 'Soins Bio',
        nameAr: 'العناية العضوية',
        types: [
          { key: 'organic-cosmetics', name: 'Cosmétiques Bio', nameAr: 'مستحضرات تجميل عضوية' },
          { key: 'organic-skincare', name: 'Soins Peau Bio', nameAr: 'عناية بالبشرة عضوية' },
          { key: 'organic-hair-care', name: 'Soins Cheveux Bio', nameAr: 'عناية بالشعر عضوية' }
        ]
      }
    }
  },
  'halal-products': {
    name: 'Produits Halal',
    nameAr: 'المنتجات الحلال',
    subcategories: {
      'halal-food': {
        name: 'Aliments Halal',
        nameAr: 'الأطعمة الحلال',
        types: [
          { key: 'halal-meat', name: 'Viande Halal', nameAr: 'لحم حلال' },
          { key: 'halal-chicken', name: 'Poulet Halal', nameAr: 'دجاج حلال' },
          { key: 'halal-processed', name: 'Produits Transformés Halal', nameAr: 'منتجات مصنعة حلال' },
          { key: 'halal-certified', name: 'Certifié Halal', nameAr: 'معتمد حلال' }
        ]
      }
    }
  },
  'vegetarian-products': {
    name: 'Produits Végétariens',
    nameAr: 'المنتجات النباتية',
    subcategories: {
      'vegetarian-food': {
        name: 'Aliments Végétariens',
        nameAr: 'الأطعمة النباتية',
        types: [
          { key: 'meat-substitutes', name: 'Substituts Viande', nameAr: 'بدائل اللحوم' },
          { key: 'vegetarian-cheese', name: 'Fromage Végétarien', nameAr: 'جبن نباتي' },
          { key: 'vegetarian-meals', name: 'Repas Végétariens', nameAr: 'وجبات نباتية' },
          { key: 'plant-based-protein', name: 'Protéines Végétales', nameAr: 'بروتينات نباتية' }
        ]
      }
    }
  },
  'vegan-products': {
    name: 'Produits Végans',
    nameAr: 'المنتجات النباتية الصرفة',
    subcategories: {
      'vegan-food': {
        name: 'Aliments Végans',
        nameAr: 'الأطعمة النباتية الصرفة',
        types: [
          { key: 'vegan-meat', name: 'Viande Végétale', nameAr: 'لحم نباتي' },
          { key: 'vegan-cheese', name: 'Fromage Végétal', nameAr: 'جبن نباتي' },
          { key: 'vegan-milk', name: 'Lait Végétal', nameAr: 'حليب نباتي' },
          { key: 'vegan-yogurt', name: 'Yaourt Végétal', nameAr: 'زبادي نباتي' },
          { key: 'vegan-desserts', name: 'Desserts Végans', nameAr: 'حلويات نباتية' }
        ]
      },
      'vegan-care': {
        name: 'Soins Végans',
        nameAr: 'العناية النباتية',
        types: [
          { key: 'vegan-cosmetics', name: 'Cosmétiques Végans', nameAr: 'مستحضرات تجميل نباتية' },
          { key: 'vegan-skincare', name: 'Soins Peau Végans', nameAr: 'عناية بالبشرة نباتية' }
        ]
      }
    }
  },
  'mauritanian-traditional': {
    name: 'Produits Traditionnels Mauritaniens',
    nameAr: 'المنتجات التقليدية الموريتانية',
    subcategories: {
      'traditional-food': {
        name: 'Plats & Aliments Traditionnels',
        nameAr: 'الأطباق والأطعمة التقليدية',
        types: [
          { key: 'thieboudienne', name: 'Thieboudienne', nameAr: 'الثيبودين' },
          { key: 'yassa', name: 'Yassa', nameAr: 'الياسا' },
          { key: 'mafe', name: 'Mafé', nameAr: 'المافي' },
          { key: 'mauritanian-couscous', name: 'Couscous Mauritanien', nameAr: 'الكسكس الموريتاني' },
          { key: 'fish-rice', name: 'Riz au Poisson', nameAr: 'أرز بالسمك' },
          { key: 'meat-rice', name: 'Riz à la Viande', nameAr: 'أرز باللحم' },
          { key: 'vegetable-rice', name: 'Riz aux Légumes', nameAr: 'أرز بالخضار' },
          { key: 'tomato-sauce', name: 'Sauce Tomate', nameAr: 'صلصة الطماطم' },
          { key: 'peanut-sauce', name: 'Sauce Arachide', nameAr: 'صلصة الفول السوداني' },
          { key: 'okra-sauce', name: 'Sauce Gombo', nameAr: 'صلصة البامية' },
          { key: 'spinach-sauce', name: 'Sauce Épinards', nameAr: 'صلصة السبانخ' },
          { key: 'sweet-potato-sauce', name: 'Sauce Patates Douces', nameAr: 'صلصة البطاطا الحلوة' },
          { key: 'traditional-bread', name: 'Pain Traditionnel', nameAr: 'الخبز التقليدي' },
          { key: 'millet-bread', name: 'Pain de Millet', nameAr: 'خبز الدخن' },
          { key: 'sorghum-bread', name: 'Pain de Sorgho', nameAr: 'خبز الذرة الرفيعة' },
          { key: 'corn-bread', name: 'Pain de Maïs', nameAr: 'خبز الذرة' },
          { key: 'date-bread', name: 'Pain aux Dattes', nameAr: 'خبز التمر' },
          { key: 'fig-bread', name: 'Pain aux Figues', nameAr: 'خبز التين' },
          { key: 'traditional-tea', name: 'Thé Traditionnel', nameAr: 'الشاي التقليدي' },
          { key: 'mint-tea', name: 'Thé à la Menthe', nameAr: 'أتاي النعناع' }
        ]
      }
    }
  },
  'restaurant-menu': buildRestaurantMenuCategoryTree()
};
